var _rect, _tspan, _tspan2, _tspan3, _tspan4, _g, _g2, _path, _g3, _g4, _path2, _path3, _path4, _path5, _g5, _rect2, _path6, _path7, _tspan5, _tspan6, _g6, _ellipse, _ellipse2, _ellipse3, _path8, _g7, _ellipse4, _path9, _tspan7, _tspan8, _path0, _path1, _path10, _path11, _path12, _path13, _tspan9, _tspan0, _tspan1, _tspan10, _tspan11, _tspan12, _tspan13, _tspan14, _tspan15, _tspan16, _tspan17, _ellipse5, _circle, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse0, _tspan18, _circle2, _tspan19, _tspan20, _path14, _path15, _path16, _ellipse1, _circle3, _circle4, _path17, _path18, _g8, _rect3, _rect4, _g9, _tspan21, _tspan22, _tspan23, _tspan24, _tspan25, _tspan26, _tspan27, _ellipse10, _path19, _ellipse11, _path20, _ellipse12, _path21, _path22, _path23, _path24, _g0, _rect5, _path25, _line, _path26, _path27, _path28, _path29, _path30, _tspan28, _g1, _g10, _rect6, _tspan29, _tspan30, _tspan31, _tspan32, _tspan33, _tspan34, _g11, _g12, _path31, _g13, _g14, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _tspan35, _tspan36, _g15, _ellipse13, _ellipse14, _ellipse15, _path39, _g16, _ellipse16, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _circle5, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _path48, _path49, _circle6, _circle7, _circle8, _path50, _path51, _path52, _tspan37, _tspan38, _tspan39, _tspan40, _tspan41, _tspan42, _tspan43, _tspan44, _tspan45, _tspan46, _tspan47, _tspan48, _ellipse21, _ellipse22, _tspan49, _tspan50, _tspan51, _path53, _path54, _tspan52, _tspan53, _tspan54, _tspan55, _tspan56, _tspan57, _tspan58, _ellipse23, _path55, _ellipse24, _path56, _ellipse25, _path57, _path58, _path59, _path60, _rect7, _path61, _line2, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _rect8, _tspan59, _path71, _ellipse26, _ellipse27, _path72, _ellipse28, _tspan60, _tspan61, _tspan62, _tspan63, _tspan64, _g17, _g18, _path73, _g19, _g20, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _tspan65, _tspan66, _g21, _ellipse29, _path81, _ellipse30, _circle9, _circle0, _path82, _path83, _path84, _tspan67, _tspan68, _tspan69, _tspan70, _tspan71, _tspan72, _tspan73, _tspan74, _tspan75, _tspan76, _ellipse31, _tspan77, _path85, _path86, _tspan78, _tspan79, _tspan80, _tspan81, _tspan82, _tspan83, _tspan84, _ellipse32, _path87, _ellipse33, _path88, _ellipse34, _path89, _path90, _path91, _path92, _rect9, _path93, _line3, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _g22, _rect0, _path102, _path103, _tspan85, _tspan86, _tspan87, _g23, _path104, _tspan88, _tspan89, _g24, _tspan90, _path105, _tspan91, _tspan92, _ellipse35, _ellipse36, _circle1, _circle10, _path106, _rect1, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _tspan93, _tspan94, _rect10, _tspan95, _tspan96, _rect11, _tspan97, _tspan98, _tspan99, _tspan100, _tspan101, _tspan102, _rect12, _rect13, _tspan103, _rect14, _tspan104, _rect15, _tspan105, _rect16, _tspan106, _tspan107, _tspan108, _tspan109, _tspan110, _g33, _g34, _path121, _g35, _g36, _path122, _path123, _path124, _path125, _path126, _ellipse37, _ellipse38, _ellipse39, _path127, _path128, _ellipse40, _path129, _path130, _tspan111, _tspan112, _tspan113, _circle11, _tspan114, _tspan115, _circle12, _circle13, _path131, _path132, _path133, _path134, _tspan116, _tspan117, _tspan118, _tspan119, _ellipse41, _ellipse42, _ellipse43, _ellipse44, _path135, _path136, _path137, _path138, _path139, _path140, _tspan120, _tspan121, _tspan122, _ellipse45, _ellipse46, _ellipse47, _ellipse48, _path141, _path142, _path143, _path144, _path145, _tspan123, _tspan124, _tspan125, _tspan126, _tspan127, _tspan128, _tspan129, _ellipse49, _path146, _ellipse50, _path147, _ellipse51, _path148, _path149, _path150, _path151, _rect17, _path152, _line4, _path153, _path154, _path155, _path156, _path157, _g37, _rect18, _tspan130, _path158, _g38, _tspan131, _tspan132, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignal4Asp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1408,
    height: 633,
    viewBox: "0 0 1408 633",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "4asp SIGNAL",
    clipPath: "url(#clip0_384_26)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1408,
    height: 633,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "NOT_TO_SET"
  }, /*#__PURE__*/React.createElement("text", {
    id: "HGNX",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 375.168,
    y: 393.15
  }, "HGNX"))), /*#__PURE__*/React.createElement("text", {
    id: "HGBX",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 375.168,
    y: 357.105
  }, "HGBX"))), /*#__PURE__*/React.createElement("g", {
    id: "CTR A5/6"
  }, /*#__PURE__*/React.createElement("text", {
    id: "CTR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 616.326,
    y: 352.599
  }, "CTR"))), /*#__PURE__*/React.createElement("text", {
    id: "CTR_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 616.326,
    y: 403.288
  }, "CTR"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 14"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2",
    cx: 636.527,
    cy: 357.644,
    rx: 2.52522,
    ry: 2.25287,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3",
    d: "M640.065 357.644C640.065 359.346 638.509 360.773 636.527 360.773C634.546 360.773 632.989 359.346 632.989 357.644C632.989 355.941 634.546 354.514 636.527 354.514C638.509 354.514 640.065 355.941 640.065 357.644Z",
    stroke: "black",
    strokeWidth: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group 15"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2_2",
    cx: 615.064,
    cy: 357.644,
    rx: 2.52522,
    ry: 2.25287,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3_2",
    d: "M618.602 357.644C618.602 359.346 617.046 360.773 615.064 360.773C613.083 360.773 611.526 359.346 611.526 357.644C611.526 355.941 613.083 354.514 615.064 354.514C617.046 354.514 618.602 355.941 618.602 357.644Z",
    stroke: "black",
    strokeWidth: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Line 33",
    d: "M618.22 357.643H633.371",
    stroke: "black",
    strokeWidth: 3
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group 17"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2_3",
    cx: 636.527,
    cy: 407.77,
    rx: 2.52522,
    ry: 2.25287,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3_3",
    d: "M640.065 407.77C640.065 409.472 638.509 410.899 636.527 410.899C634.546 410.899 632.989 409.472 632.989 407.77C632.989 406.068 634.546 404.641 636.527 404.641C638.509 404.641 640.065 406.068 640.065 407.77Z",
    stroke: "black",
    strokeWidth: 0.5
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group 18"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2_4",
    cx: 615.064,
    cy: 407.77,
    rx: 2.52522,
    ry: 2.25287,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3_4",
    d: "M618.602 407.77C618.602 409.472 617.046 410.899 615.064 410.899C613.083 410.899 611.526 409.472 611.526 407.77C611.526 406.068 613.083 404.641 615.064 404.641C617.046 404.641 618.602 406.068 618.602 407.77Z",
    stroke: "black",
    strokeWidth: 0.5
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Line 37",
    d: "M618.22 407.77H633.371",
    stroke: "black",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 57",
    d: "M637.791 361.586H639.685L641.579 359.615V357.643V355.672L639.685 353.701H637.791",
    stroke: "black",
    strokeWidth: 0.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 58",
    d: "M637.791 411.713H639.685L641.579 409.741V407.77V405.799L639.685 403.828H637.791",
    stroke: "black",
    strokeWidth: 0.25
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Location Box"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "LB2TRACKSIDE_HG_DN_WIRE",
    d: "M838.545 395.379V407.77H641.578",
    stroke: "black",
    strokeWidth: 2
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "TO_SET_LOCATION BOX"
  }, /*#__PURE__*/React.createElement("path", {
    id: "LB2TRACKSIDE_HG_UP_WIRE",
    d: "M838.545 368.345V357.644H641.578",
    stroke: "black",
    strokeWidth: 2
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 11",
    x: 650.153,
    y: 12.2644,
    width: 102.797,
    height: 574.736,
    stroke: "black",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TO_NOT_SET_LOCATIONBOX"
  }, /*#__PURE__*/React.createElement("g", {
    id: "S1HPR"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 53",
    d: "M677.563 354.827L679.457 357.08L681.351 354.827",
    stroke: "black",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 54",
    d: "M708.497 404.391L710.391 406.644L712.285 404.391",
    stroke: "black",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "HPR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 678.194,
    y: 352.599
  }, "HPR"))), /*#__PURE__*/React.createElement("text", {
    id: "HPR_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 679.457,
    y: 403.288
  }, "HPR"))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group 13"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2_5",
    cx: 722.387,
    cy: 357.644,
    rx: 2.52522,
    ry: 2.25287,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3_5",
    d: "M725.174 357.644C725.174 358.853 724.036 360.023 722.386 360.023C720.736 360.023 719.599 358.853 719.599 357.644C719.599 356.434 720.736 355.264 722.386 355.264C724.036 355.264 725.174 356.434 725.174 357.644Z",
    stroke: "black",
    strokeWidth: 2
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 60",
    cx: 670.619,
    cy: 357.644,
    rx: 2.52522,
    ry: 2.25287,
    fill: "black"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 61",
    cx: 670.619,
    cy: 407.77,
    rx: 2.52522,
    ry: 2.25287,
    fill: "black"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 62",
    cx: 709.76,
    cy: 358.207,
    rx: 2.52522,
    ry: 2.25287,
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 63",
    d: "M673.407 357.644C673.407 358.853 672.269 360.023 670.619 360.023C668.969 360.023 667.831 358.853 667.831 357.644C667.831 356.434 668.969 355.264 670.619 355.264C672.269 355.264 673.407 356.434 673.407 357.644Z",
    stroke: "black",
    strokeWidth: 2
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group 16"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2_6",
    cx: 722.386,
    cy: 407.77,
    rx: 2.52522,
    ry: 2.25287,
    transform: "rotate(-180 722.386 407.77)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3_6",
    d: "M719.598 407.77C719.598 406.56 720.736 405.391 722.386 405.391C724.036 405.391 725.174 406.56 725.174 407.77C725.174 408.98 724.036 410.149 722.386 410.149C720.736 410.149 719.598 408.98 719.598 407.77Z",
    stroke: "black",
    strokeWidth: 2
  }))), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 64",
    cx: 684.508,
    cy: 407.333,
    rx: 2.52522,
    ry: 2.25287,
    transform: "rotate(-180 684.508 407.333)",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 65",
    d: "M667.832 407.77C667.832 406.56 668.969 405.391 670.619 405.391C672.269 405.391 673.407 406.56 673.407 407.77C673.407 408.98 672.269 410.149 670.619 410.149C668.969 410.149 667.832 408.98 667.832 407.77Z",
    stroke: "black",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Location Box_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 678.194,
    y: 9.03556
  }, "Location Box"))))), /*#__PURE__*/React.createElement("g", {
    id: "RELAY ROOM"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TO_NOT_SET_RELAYRACK"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 129"
  }, /*#__PURE__*/React.createElement("text", {
    id: "RELAY RACK",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 188.301,
    y: 7.90909
  }, "RELAY RACK"))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 43",
    d: "M284.259 330.609L280.471 325.54L276.683 330.609",
    stroke: "black",
    strokeWidth: 2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 44",
    d: "M233.756 363.276L229.968 358.77L226.18 363.276",
    stroke: "black",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 48",
    d: "M227.441 319.345L231.229 323.851L235.017 319.345",
    stroke: "black",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 49",
    d: "M203.452 391.437L206.609 395.942L211.028 391.437",
    stroke: "black",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 50",
    d: "M175.675 354.264L179.463 358.77L183.25 354.264",
    stroke: "black",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 51",
    d: "M248.906 422.977L252.063 427.483L256.482 422.977",
    stroke: "black",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "R2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: 310.773,
    y: 393.15
  }, "R2"))), /*#__PURE__*/React.createElement("text", {
    id: "R1",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan0 || (_tspan0 = /*#__PURE__*/React.createElement("tspan", {
    x: 361.278,
    y: 393.15
  }, "R1"))), /*#__PURE__*/React.createElement("text", {
    id: "HR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan1 || (_tspan1 = /*#__PURE__*/React.createElement("tspan", {
    x: 188.301,
    y: 388.645
  }, "HR"))), /*#__PURE__*/React.createElement("text", {
    id: "HR_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: 185.776,
    y: 351.472
  }, "HR"))), /*#__PURE__*/React.createElement("text", {
    id: "DECR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    x: 306.986,
    y: 318.806
  }, "DECR"))), /*#__PURE__*/React.createElement("text", {
    id: "DR1",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    x: 240.543,
    y: 419.185
  }, "DR1"))), /*#__PURE__*/React.createElement("text", {
    id: "DECPR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    x: 274.733,
    y: 418.311
  }, "DECPR"))), /*#__PURE__*/React.createElement("text", {
    id: "DR1_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    x: 237.543,
    y: 388.645
  }, "DR1"))), /*#__PURE__*/React.createElement("text", {
    id: "DR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    x: 262.795,
    y: 370.622
  }, "DR"))), /*#__PURE__*/React.createElement("text", {
    id: "DR_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan16 || (_tspan16 = /*#__PURE__*/React.createElement("tspan", {
    x: 253.956,
    y: 318.806
  }, "DR"))), /*#__PURE__*/React.createElement("text", {
    id: "HECR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan17 || (_tspan17 = /*#__PURE__*/React.createElement("tspan", {
    x: 334.764,
    y: 406.668
  }, "HECR"))), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 47",
    cx: 204.715,
    cy: 358.77,
    rx: 3.78783,
    ry: 3.37931,
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48",
    cx: 181.699,
    cy: 396.063,
    r: 3.5,
    fill: "black"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 49",
    cx: 247.643,
    cy: 324.977,
    rx: 3.78783,
    ry: 3.37931,
    fill: "black"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 51",
    cx: 231.229,
    cy: 394.816,
    rx: 3.78783,
    ry: 3.37931,
    fill: "black"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 52",
    cx: 231.229,
    cy: 427.483,
    rx: 3.78783,
    ry: 3.37931,
    fill: "black"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 53",
    cx: 275.422,
    cy: 427.483,
    rx: 3.78783,
    ry: 3.37931,
    fill: "black"
  })), _ellipse0 || (_ellipse0 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 54",
    cx: 300.674,
    cy: 324.977,
    rx: 3.78783,
    ry: 3.37931,
    fill: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "0.6A",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan18 || (_tspan18 = /*#__PURE__*/React.createElement("tspan", {
    x: 131.484,
    y: 350.346
  }, "0.6A"))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 91",
    cx: 128.67,
    cy: 397.19,
    r: 3.5,
    fill: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "BX110",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan19 || (_tspan19 = /*#__PURE__*/React.createElement("tspan", {
    x: 89,
    y: 362.909
  }, "BX110"))), /*#__PURE__*/React.createElement("text", {
    id: "NX110",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan20 || (_tspan20 = /*#__PURE__*/React.createElement("tspan", {
    x: 89,
    y: 404.587
  }, "NX110")))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 42",
    d: "M319.612 395.379V411.15H367.591V395.379",
    stroke: "black",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 45",
    d: "M260.271 401.575L255.851 397.069L252.695 401.575",
    stroke: "black",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 46",
    d: "M304.461 433.115L300.673 428.046L296.885 433.115",
    stroke: "black",
    strokeWidth: 2
  })), _ellipse1 || (_ellipse1 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 45",
    cx: 256.482,
    cy: 357.644,
    rx: 3.78783,
    ry: 3.37931,
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 92",
    cx: 130.434,
    cy: 359.207,
    r: 4,
    fill: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 93",
    cx: 150.635,
    cy: 359.207,
    r: 4,
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 60",
    d: "M229.967 357.869L219.866 352.8V325.202H308.88V352.8H272.265L260.27 357.869",
    stroke: "black",
    strokeWidth: 2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 61",
    d: "M255.85 395.942L269.108 401.011H310.143V427.708H221.129V400.11L230.598 395.041",
    stroke: "black",
    strokeWidth: 2
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "TO_SET_REALY RACK"
  }, /*#__PURE__*/React.createElement("path", {
    id: "RR_UP_WIRE_HG",
    d: "M442.086 357.644L127.696 359.3",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "RR_DN_WIRE_HG",
    d: "M442.086 394.816L127.696 396.513",
    stroke: "black",
    strokeWidth: 2
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 13",
    x: 34,
    y: 12.2643,
    width: 337.642,
    height: 574.736,
    stroke: "black",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "CT RACK"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 12",
    x: 416.57,
    y: 12.2643,
    width: 178.553,
    height: 574.736,
    stroke: "black",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "SPD2CTR_MONITOR_HG"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SPD2CTR_HG_UP_WIRE",
    d: "M468.601 357.643H611.423",
    stroke: "black",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "TO_NOT_SET_CTRACK"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B19SPD"
  }, /*#__PURE__*/React.createElement("text", {
    id: 6,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan21 || (_tspan21 = /*#__PURE__*/React.createElement("tspan", {
    x: 439.56,
    y: 368.369
  }, "6"))), /*#__PURE__*/React.createElement("text", {
    id: 5,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan22 || (_tspan22 = /*#__PURE__*/React.createElement("tspan", {
    x: 462.287,
    y: 368.369
  }, "5"))), /*#__PURE__*/React.createElement("text", {
    id: 1,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan23 || (_tspan23 = /*#__PURE__*/React.createElement("tspan", {
    x: 462.287,
    y: 405.541
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    id: 2,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan24 || (_tspan24 = /*#__PURE__*/React.createElement("tspan", {
    x: 440.822,
    y: 405.541
  }, "2"))), /*#__PURE__*/React.createElement("text", {
    id: 4,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan25 || (_tspan25 = /*#__PURE__*/React.createElement("tspan", {
    x: 440.822,
    y: 421.311
  }, "4"))), /*#__PURE__*/React.createElement("text", {
    id: 3,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan26 || (_tspan26 = /*#__PURE__*/React.createElement("tspan", {
    x: 462.287,
    y: 421.311
  }, "3"))), /*#__PURE__*/React.createElement("text", {
    id: "SPD",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan27 || (_tspan27 = /*#__PURE__*/React.createElement("tspan", {
    x: 440.822,
    y: 345.84
  }, "SPD"))), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 44",
    cx: 443.347,
    cy: 357.644,
    rx: 3.78783,
    ry: 3.37931,
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 55",
    d: "M467.6 357.644C467.6 358.854 466.462 360.023 464.812 360.023C463.162 360.023 462.024 358.854 462.024 357.644C462.024 356.434 463.162 355.264 464.812 355.264C466.462 355.264 467.6 356.434 467.6 357.644Z",
    stroke: "black",
    strokeWidth: 2
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 56",
    cx: 443.347,
    cy: 394.816,
    rx: 3.78783,
    ry: 3.37931,
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 57",
    d: "M467.6 394.816C467.6 396.026 466.462 397.195 464.812 397.195C463.162 397.195 462.024 396.026 462.024 394.816C462.024 393.606 463.162 392.437 464.812 392.437C466.462 392.437 467.6 393.606 467.6 394.816Z",
    stroke: "black",
    strokeWidth: 2
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 58",
    cx: 443.347,
    cy: 410.586,
    rx: 3.78783,
    ry: 3.37931,
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 59",
    d: "M467.6 410.586C467.6 411.796 466.462 412.965 464.812 412.965C463.162 412.965 462.024 411.796 462.024 410.586C462.024 409.376 463.162 408.207 464.812 408.207C466.462 408.207 467.6 409.376 467.6 410.586Z",
    stroke: "black",
    strokeWidth: 2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Line 34",
    d: "M445.873 357.644H461.656",
    stroke: "black",
    strokeWidth: 2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Line 35",
    d: "M445.873 394.816H461.656",
    stroke: "black",
    strokeWidth: 2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Line 36",
    d: "M445.873 410.586H461.656",
    stroke: "black",
    strokeWidth: 2
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "TO_SET_CT RACK"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SPD2CTR_HG_DN_WIRE",
    d: "M488.803 407.77H611.276",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "SPD2CTR_HG_DN_WIRE_2",
    d: "M468.601 394.816H488.802V408.333",
    stroke: "black",
    strokeWidth: 2
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 8",
    x: 432,
    y: 349,
    width: 44,
    height: 74,
    stroke: "black",
    strokeWidth: 2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Line 40",
    d: "M454.711 426.356V411.118",
    stroke: "black",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line 41",
    x1: 448.398,
    y1: 425.919,
    x2: 461.025,
    y2: 425.919,
    stroke: "black",
    strokeWidth: 2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Line 42",
    d: "M449.661 427.342H460.155",
    stroke: "black",
    strokeWidth: 2
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Line 43",
    d: "M450.924 427.821H458.499",
    stroke: "black",
    strokeWidth: 2
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Line 44",
    d: "M452.187 428.328H457.237",
    stroke: "black",
    strokeWidth: 2
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Line 45",
    d: "M453.449 428.947H455.974",
    stroke: "black",
    strokeWidth: 2
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Line 48",
    d: "M452.187 428.328H457.237",
    stroke: "black",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("text", {
    id: "CT RACK_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan28 || (_tspan28 = /*#__PURE__*/React.createElement("tspan", {
    x: 491.327,
    y: 9.03549
  }, "CT RACK"))))), /*#__PURE__*/React.createElement("g", {
    id: "TRACK SIDE SIGNAL UNIT"
  }, _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "SIGNAL_UNIT"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1",
    x: 787.778,
    y: 12.2644,
    width: 95.221,
    height: 574.736,
    stroke: "black",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LED Signal HHG"
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "TO_SET_SIGNALUNIT"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4ASP_LED Signal RG"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1",
    d: "M852.697 382.425C852.697 389.545 846.189 395.506 837.914 395.506C829.64 395.506 823.132 389.545 823.132 382.425C823.132 375.305 829.64 369.345 837.914 369.345C846.189 369.345 852.697 375.305 852.697 382.425Z",
    stroke: "black",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "TO_NOT_SET_SIGNALUNIT"
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 5",
    x: 813.031,
    y: 349.069,
    width: 48.5044,
    height: 66.7126,
    stroke: "black",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "HG",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 6,
    letterSpacing: "0em"
  }, _tspan29 || (_tspan29 = /*#__PURE__*/React.createElement("tspan", {
    x: 863.798,
    y: 388.67
  }, "HG"))))), /*#__PURE__*/React.createElement("text", {
    id: "SU_SIGNAL_NUMBER",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Open Sans",
    fontSize: 6,
    letterSpacing: "0em"
  }, _tspan30 || (_tspan30 = /*#__PURE__*/React.createElement("tspan", {
    x: 813.902,
    y: 9.70697
  }, "SIGNAL UNIT")))), /*#__PURE__*/React.createElement("g", {
    id: "HHG_Wiring"
  }, /*#__PURE__*/React.createElement("text", {
    id: "S1HHGNX",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan31 || (_tspan31 = /*#__PURE__*/React.createElement("tspan", {
    x: 375.168,
    y: 105.909
  }, "S1HHGNX"))), /*#__PURE__*/React.createElement("text", {
    id: "S1HHGBX",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan32 || (_tspan32 = /*#__PURE__*/React.createElement("tspan", {
    x: 375.168,
    y: 69.8631
  }, "S1HHGBX"))), /*#__PURE__*/React.createElement("g", {
    id: "CRT A5/4"
  }, /*#__PURE__*/React.createElement("text", {
    id: "CTR_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan33 || (_tspan33 = /*#__PURE__*/React.createElement("tspan", {
    x: 616.326,
    y: 65.3573
  }, "CTR"))), /*#__PURE__*/React.createElement("text", {
    id: "CTR_4",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan34 || (_tspan34 = /*#__PURE__*/React.createElement("tspan", {
    x: 616.326,
    y: 116.047
  }, "CTR"))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2_7",
    cx: 636.527,
    cy: 70.4022,
    rx: 2.52522,
    ry: 2.25287,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3_7",
    d: "M640.065 70.4022C640.065 72.1044 638.509 73.5315 636.527 73.5315C634.546 73.5315 632.989 72.1044 632.989 70.4022C632.989 68.7 634.546 67.2729 636.527 67.2729C638.509 67.2729 640.065 68.7 640.065 70.4022Z",
    stroke: "black",
    strokeWidth: 0.5
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group 4"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2_8",
    cx: 615.064,
    cy: 70.4022,
    rx: 2.52522,
    ry: 2.25287,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3_8",
    d: "M618.602 70.4022C618.602 72.1044 617.046 73.5315 615.064 73.5315C613.083 73.5315 611.526 72.1044 611.526 70.4022C611.526 68.7 613.083 67.2729 615.064 67.2729C617.046 67.2729 618.602 68.7 618.602 70.4022Z",
    stroke: "black",
    strokeWidth: 0.5
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Line 1",
    d: "M618.22 70.4023H633.371",
    stroke: "black",
    strokeWidth: 3
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group 5"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2_9",
    cx: 636.527,
    cy: 120.529,
    rx: 2.52522,
    ry: 2.25287,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3_9",
    d: "M640.065 120.529C640.065 122.231 638.509 123.658 636.527 123.658C634.546 123.658 632.989 122.231 632.989 120.529C632.989 118.827 634.546 117.399 636.527 117.399C638.509 117.399 640.065 118.827 640.065 120.529Z",
    stroke: "black",
    strokeWidth: 0.5
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group 6"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2_10",
    cx: 615.064,
    cy: 120.529,
    rx: 2.52522,
    ry: 2.25287,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3_10",
    d: "M618.602 120.529C618.602 122.231 617.046 123.658 615.064 123.658C613.083 123.658 611.526 122.231 611.526 120.529C611.526 118.827 613.083 117.399 615.064 117.399C617.046 117.399 618.602 118.827 618.602 120.529Z",
    stroke: "black",
    strokeWidth: 0.5
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Line 2",
    d: "M618.22 120.529H633.371",
    stroke: "black",
    strokeWidth: 3
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 6",
    d: "M637.791 74.3448H639.685L641.579 72.3735V70.4022V68.431L639.685 66.4597H637.791",
    stroke: "black",
    strokeWidth: 0.25
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 7",
    d: "M637.791 124.471H639.685L641.579 122.5V120.529V118.557L639.685 116.586H637.791",
    stroke: "black",
    strokeWidth: 0.25
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "LB2TRACKSIDE_HHG_UP_WIRE",
    d: "M838.545 81.1034V70.4023H641.578",
    stroke: "black",
    strokeWidth: 2
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "LB2TRACKSIDE_HHG_DN_WIRE",
    d: "M838.545 108.138V120.529H641.578",
    stroke: "black",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "S1HHPR"
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 4",
    d: "M677.563 67.5863L679.457 69.8392L681.351 67.5863",
    stroke: "black",
    strokeWidth: 2
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 5",
    d: "M708.497 117.15L710.391 119.402L712.285 117.15",
    stroke: "black",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "HHPR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan35 || (_tspan35 = /*#__PURE__*/React.createElement("tspan", {
    x: 678.194,
    y: 65.3575
  }, "HHPR"))), /*#__PURE__*/React.createElement("text", {
    id: "HHPR_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan36 || (_tspan36 = /*#__PURE__*/React.createElement("tspan", {
    x: 679.457,
    y: 116.047
  }, "HHPR"))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2_11",
    cx: 722.387,
    cy: 70.4024,
    rx: 2.52522,
    ry: 2.25287,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3_11",
    d: "M725.174 70.4024C725.174 71.6122 724.036 72.7817 722.386 72.7817C720.736 72.7817 719.599 71.6122 719.599 70.4024C719.599 69.1926 720.736 68.0231 722.386 68.0231C724.036 68.0231 725.174 69.1926 725.174 70.4024Z",
    stroke: "black",
    strokeWidth: 2
  }))), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2_12",
    cx: 670.619,
    cy: 70.4024,
    rx: 2.52522,
    ry: 2.25287,
    fill: "black"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 7",
    cx: 670.619,
    cy: 120.529,
    rx: 2.52522,
    ry: 2.25287,
    fill: "black"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 4",
    cx: 709.76,
    cy: 70.9656,
    rx: 2.52522,
    ry: 2.25287,
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3_12",
    d: "M673.407 70.4024C673.407 71.6122 672.269 72.7817 670.619 72.7817C668.969 72.7817 667.831 71.6122 667.831 70.4024C667.831 69.1926 668.969 68.0231 670.619 68.0231C672.269 68.0231 673.407 69.1926 673.407 70.4024Z",
    stroke: "black",
    strokeWidth: 2
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group 2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2_13",
    cx: 722.386,
    cy: 120.529,
    rx: 2.52522,
    ry: 2.25287,
    transform: "rotate(-180 722.386 120.529)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3_13",
    d: "M719.598 120.529C719.598 119.319 720.736 118.149 722.386 118.149C724.036 118.149 725.174 119.319 725.174 120.529C725.174 121.739 724.036 122.908 722.386 122.908C720.736 122.908 719.598 121.739 719.598 120.529Z",
    stroke: "black",
    strokeWidth: 2
  }))), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 5",
    cx: 684.508,
    cy: 121.092,
    rx: 2.52522,
    ry: 2.25287,
    transform: "rotate(-180 684.508 121.092)",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 6",
    d: "M667.832 120.529C667.832 119.319 668.969 118.149 670.619 118.149C672.269 118.149 673.407 119.319 673.407 120.529C673.407 121.739 672.269 122.908 670.619 122.908C668.969 122.908 667.832 121.739 667.832 120.529Z",
    stroke: "black",
    strokeWidth: 2
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 19",
    d: "M318.351 108.138V123.908H365.067V108.138",
    stroke: "black",
    strokeWidth: 2
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 11",
    d: "M276.684 43.3678L273.527 38.8621L269.108 43.3678",
    stroke: "black",
    strokeWidth: 2
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 15",
    d: "M233.756 77.1609L230.599 72.6552L226.18 77.1609",
    stroke: "black",
    strokeWidth: 2
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 16",
    d: "M260.271 113.207L255.851 108.701L252.695 113.207",
    stroke: "black",
    strokeWidth: 2
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 18",
    d: "M227.441 32.1035L230.598 36.6092L235.017 32.1035",
    stroke: "black",
    strokeWidth: 2
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 20",
    d: "M187.039 103.195L190.196 107.701L194.615 103.195",
    stroke: "black",
    strokeWidth: 2
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 14",
    d: "M296.886 103.069L300.042 107.575L304.461 103.069",
    stroke: "black",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 21",
    cx: 169.574,
    cy: 109.322,
    r: 4,
    fill: "black"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 14",
    cx: 247.643,
    cy: 37.7356,
    rx: 3.78783,
    ry: 3.37931,
    fill: "black"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 16",
    cx: 282.997,
    cy: 107.575,
    rx: 3.78783,
    ry: 3.37931,
    fill: "black"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 17",
    cx: 231.229,
    cy: 107.575,
    rx: 3.78783,
    ry: 3.37931,
    fill: "black"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 15",
    cx: 300.674,
    cy: 37.7356,
    rx: 3.78783,
    ry: 3.37931,
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 9",
    d: "M230.598 71.5287L219.866 65.5585V37.9608H308.88V65.5585L299.411 70.6275",
    stroke: "black",
    strokeWidth: 2
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 10",
    d: "M300.042 107.8L310.143 112.869V140.467H221.129V112.869L230.598 107.8",
    stroke: "black",
    strokeWidth: 2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 97",
    cx: 130.434,
    cy: 71.9656,
    r: 4,
    fill: "black"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98",
    cx: 150.635,
    cy: 71.9656,
    r: 4,
    fill: "black"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99",
    cx: 129.17,
    cy: 109.448,
    r: 4,
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 17",
    d: "M303.198 145.874L298.779 141.368L295.623 145.874",
    stroke: "black",
    strokeWidth: 2
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 12",
    d: "M277.946 65.8965L281.103 70.4023L285.522 65.8965",
    stroke: "black",
    strokeWidth: 2
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 13",
    d: "M243.855 135.735L247.012 140.241L251.431 135.735",
    stroke: "black",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "R2_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan37 || (_tspan37 = /*#__PURE__*/React.createElement("tspan", {
    x: 313.3,
    y: 105.909
  }, "R2"))), /*#__PURE__*/React.createElement("text", {
    id: "R1_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan38 || (_tspan38 = /*#__PURE__*/React.createElement("tspan", {
    x: 358.753,
    y: 105.909
  }, "R1"))), /*#__PURE__*/React.createElement("text", {
    id: "HR_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan39 || (_tspan39 = /*#__PURE__*/React.createElement("tspan", {
    x: 197.139,
    y: 64.2309
  }, "HR"))), /*#__PURE__*/React.createElement("text", {
    id: "DR_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan40 || (_tspan40 = /*#__PURE__*/React.createElement("tspan", {
    x: 255.219,
    y: 31.5642
  }, "DR"))), /*#__PURE__*/React.createElement("text", {
    id: "DR_4",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan41 || (_tspan41 = /*#__PURE__*/React.createElement("tspan", {
    x: 253.956,
    y: 84.5068
  }, "DR"))), /*#__PURE__*/React.createElement("text", {
    id: "DECR_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan42 || (_tspan42 = /*#__PURE__*/React.createElement("tspan", {
    x: 308.249,
    y: 31.5642
  }, "DECR"))), /*#__PURE__*/React.createElement("text", {
    id: "HR_4",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan43 || (_tspan43 = /*#__PURE__*/React.createElement("tspan", {
    x: 175.675,
    y: 102.53
  }, "HR"))), /*#__PURE__*/React.createElement("text", {
    id: "HHR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan44 || (_tspan44 = /*#__PURE__*/React.createElement("tspan", {
    x: 308.249,
    y: 83.3803
  }, "HHR"))), /*#__PURE__*/React.createElement("text", {
    id: "HHR_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan45 || (_tspan45 = /*#__PURE__*/React.createElement("tspan", {
    x: 289.311,
    y: 101.403
  }, "HHR"))), /*#__PURE__*/React.createElement("text", {
    id: "DR1_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan46 || (_tspan46 = /*#__PURE__*/React.createElement("tspan", {
    x: 237.543,
    y: 134.07
  }, "DR1"))), /*#__PURE__*/React.createElement("text", {
    id: "DR1_4",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan47 || (_tspan47 = /*#__PURE__*/React.createElement("tspan", {
    x: 238.806,
    y: 101.403
  }, "DR1"))), /*#__PURE__*/React.createElement("text", {
    id: "HHECR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan48 || (_tspan48 = /*#__PURE__*/React.createElement("tspan", {
    x: 334.764,
    y: 119.426
  }, "HHECR"))), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 12",
    cx: 300.674,
    cy: 70.4023,
    rx: 3.78783,
    ry: 3.37931,
    fill: "black"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 13",
    cx: 247.643,
    cy: 71.5287,
    rx: 3.78783,
    ry: 3.37931,
    fill: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "DECPR_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan49 || (_tspan49 = /*#__PURE__*/React.createElement("tspan", {
    x: 281.259,
    y: 134.07
  }, "DECPR"))), /*#__PURE__*/React.createElement("text", {
    id: "BX110_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan50 || (_tspan50 = /*#__PURE__*/React.createElement("tspan", {
    x: 88.3027,
    y: 76.7597
  }, "BX110"))), /*#__PURE__*/React.createElement("text", {
    id: "NX110_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan51 || (_tspan51 = /*#__PURE__*/React.createElement("tspan", {
    x: 88.3027,
    y: 115.438
  }, "NX110"))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "RR_UP_WIRE_HHG",
    d: "M442.086 70.4023L127.696 72.0587",
    stroke: "black",
    strokeWidth: 2
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "RR_DN_WIRE_HHG",
    d: "M442.086 107.575L127.696 109.271",
    stroke: "black",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "B17 SPD"
  }, /*#__PURE__*/React.createElement("text", {
    id: "6_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan52 || (_tspan52 = /*#__PURE__*/React.createElement("tspan", {
    x: 439.56,
    y: 81.1274
  }, "6"))), /*#__PURE__*/React.createElement("text", {
    id: "5_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan53 || (_tspan53 = /*#__PURE__*/React.createElement("tspan", {
    x: 462.287,
    y: 81.1274
  }, "5"))), /*#__PURE__*/React.createElement("text", {
    id: "1_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan54 || (_tspan54 = /*#__PURE__*/React.createElement("tspan", {
    x: 462.287,
    y: 118.3
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    id: "2_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan55 || (_tspan55 = /*#__PURE__*/React.createElement("tspan", {
    x: 440.822,
    y: 118.3
  }, "2"))), /*#__PURE__*/React.createElement("text", {
    id: "4_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan56 || (_tspan56 = /*#__PURE__*/React.createElement("tspan", {
    x: 440.822,
    y: 134.07
  }, "4"))), /*#__PURE__*/React.createElement("text", {
    id: "3_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan57 || (_tspan57 = /*#__PURE__*/React.createElement("tspan", {
    x: 462.287,
    y: 134.07
  }, "3"))), /*#__PURE__*/React.createElement("text", {
    id: "SPD_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan58 || (_tspan58 = /*#__PURE__*/React.createElement("tspan", {
    x: 440.822,
    y: 58.5988
  }, " SPD"))), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2_14",
    cx: 443.347,
    cy: 70.4023,
    rx: 3.78783,
    ry: 3.37931,
    fill: "black"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3_14",
    d: "M467.6 70.4023C467.6 71.6121 466.462 72.7816 464.812 72.7816C463.162 72.7816 462.024 71.6121 462.024 70.4023C462.024 69.1925 463.162 68.023 464.812 68.023C466.462 68.023 467.6 69.1925 467.6 70.4023Z",
    stroke: "black",
    strokeWidth: 2
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 8",
    cx: 443.347,
    cy: 107.575,
    rx: 3.78783,
    ry: 3.37931,
    fill: "black"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 9",
    d: "M467.6 107.575C467.6 108.784 466.462 109.954 464.812 109.954C463.162 109.954 462.024 108.784 462.024 107.575C462.024 106.365 463.162 105.195 464.812 105.195C466.462 105.195 467.6 106.365 467.6 107.575Z",
    stroke: "black",
    strokeWidth: 2
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 10",
    cx: 443.347,
    cy: 123.345,
    rx: 3.78783,
    ry: 3.37931,
    fill: "black"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 11",
    d: "M467.6 123.345C467.6 124.555 466.462 125.724 464.812 125.724C463.162 125.724 462.024 124.555 462.024 123.345C462.024 122.135 463.162 120.965 464.812 120.965C466.462 120.965 467.6 122.135 467.6 123.345Z",
    stroke: "black",
    strokeWidth: 2
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Line 5",
    d: "M445.873 70.4023H461.656",
    stroke: "black",
    strokeWidth: 2
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Line 6",
    d: "M445.873 107.575H461.656",
    stroke: "black",
    strokeWidth: 2
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Line 7",
    d: "M445.873 123.345H461.656",
    stroke: "black",
    strokeWidth: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 6",
    x: 432,
    y: 62,
    width: 44,
    height: 73,
    stroke: "black",
    strokeWidth: 2
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Line 8",
    d: "M454.711 139.115V123.877",
    stroke: "black",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line 9",
    x1: 448.398,
    y1: 138.678,
    x2: 461.025,
    y2: 138.678,
    stroke: "black",
    strokeWidth: 2
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Line 10",
    d: "M449.661 140.101H460.155",
    stroke: "black",
    strokeWidth: 2
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Line 11",
    d: "M450.924 140.579H458.499",
    stroke: "black",
    strokeWidth: 2
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Line 12",
    d: "M452.187 141.086H457.237",
    stroke: "black",
    strokeWidth: 2
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Line 13",
    d: "M453.449 141.706H455.974",
    stroke: "black",
    strokeWidth: 2
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Line 15",
    d: "M452.187 141.086H457.237",
    stroke: "black",
    strokeWidth: 2
  }))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "SPD2CTR_HHG_DN_WIRE",
    d: "M488.803 120.529L611.276 120.529",
    stroke: "black",
    strokeWidth: 2
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "SPD2CTR_HHG_DN_WIRE_2",
    d: "M468.602 107.575H488.803V121.092",
    stroke: "black",
    strokeWidth: 2
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "SPD2CTR_HHG_UP_WIRE",
    d: "M467.97 70.4023H611.055",
    stroke: "black",
    strokeWidth: 2
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1_2",
    d: "M851.434 94.0575C851.434 101.177 844.926 107.138 836.652 107.138C828.377 107.138 821.869 101.177 821.869 94.0575C821.869 86.9376 828.377 80.9771 836.652 80.9771C844.926 80.9771 851.434 86.9376 851.434 94.0575Z",
    stroke: "black",
    strokeWidth: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2",
    x: 811.769,
    y: 62.954,
    width: 48.5044,
    height: 66.7126,
    stroke: "black",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "HHG",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 6,
    letterSpacing: "0em"
  }, _tspan59 || (_tspan59 = /*#__PURE__*/React.createElement("tspan", {
    x: 862.535,
    y: 98.0497
  }, "HHG"))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Line 150",
    d: "M131 72.8709C140.13 49.6246 141 94.6335 151 72.8709",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 163"
  }, _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 18",
    cx: 231.229,
    cy: 140.241,
    rx: 3.78783,
    ry: 3.37931,
    fill: "black"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 19",
    cx: 277.946,
    cy: 140.241,
    rx: 3.78783,
    ry: 3.37931,
    fill: "black"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 21",
    d: "M165.312 66.023L168.468 70.5288L172.887 66.023",
    stroke: "black",
    strokeWidth: 2
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 20",
    cx: 189.564,
    cy: 71.5287,
    rx: 3.78783,
    ry: 3.37931,
    fill: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "0.6A_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan60 || (_tspan60 = /*#__PURE__*/React.createElement("tspan", {
    x: 131.484,
    y: 63.1045
  }, "0.6A"))))), /*#__PURE__*/React.createElement("g", {
    id: "DG_Wiring"
  }, /*#__PURE__*/React.createElement("text", {
    id: "S1DGNX",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan61 || (_tspan61 = /*#__PURE__*/React.createElement("tspan", {
    x: 375.168,
    y: 248.967
  }, "S1DGNX"))), /*#__PURE__*/React.createElement("text", {
    id: "S1DGBX",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan62 || (_tspan62 = /*#__PURE__*/React.createElement("tspan", {
    x: 375.168,
    y: 212.921
  }, "S1DGBX"))), /*#__PURE__*/React.createElement("g", {
    id: "CTR A5/5"
  }, /*#__PURE__*/React.createElement("text", {
    id: "CTR_5",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan63 || (_tspan63 = /*#__PURE__*/React.createElement("tspan", {
    x: 616.326,
    y: 208.415
  }, "CTR"))), /*#__PURE__*/React.createElement("text", {
    id: "CTR_6",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan64 || (_tspan64 = /*#__PURE__*/React.createElement("tspan", {
    x: 616.326,
    y: 259.104
  }, "CTR"))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group 8"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2_15",
    cx: 636.527,
    cy: 213.46,
    rx: 2.52522,
    ry: 2.25287,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3_15",
    d: "M640.065 213.46C640.065 215.162 638.509 216.589 636.527 216.589C634.546 216.589 632.989 215.162 632.989 213.46C632.989 211.757 634.546 210.33 636.527 210.33C638.509 210.33 640.065 211.757 640.065 213.46Z",
    stroke: "black",
    strokeWidth: 0.5
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group 9"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2_16",
    cx: 615.064,
    cy: 213.46,
    rx: 2.52522,
    ry: 2.25287,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3_16",
    d: "M618.602 213.46C618.602 215.162 617.046 216.589 615.064 216.589C613.083 216.589 611.526 215.162 611.526 213.46C611.526 211.757 613.083 210.33 615.064 210.33C617.046 210.33 618.602 211.757 618.602 213.46Z",
    stroke: "black",
    strokeWidth: 0.5
  }))), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Line 17",
    d: "M618.22 213.46H633.371",
    stroke: "black",
    strokeWidth: 3
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group 11"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2_17",
    cx: 636.527,
    cy: 263.586,
    rx: 2.52522,
    ry: 2.25287,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3_17",
    d: "M640.065 263.586C640.065 265.288 638.509 266.715 636.527 266.715C634.546 266.715 632.989 265.288 632.989 263.586C632.989 261.884 634.546 260.457 636.527 260.457C638.509 260.457 640.065 261.884 640.065 263.586Z",
    stroke: "black",
    strokeWidth: 0.5
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group 12"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2_18",
    cx: 615.064,
    cy: 263.586,
    rx: 2.52522,
    ry: 2.25287,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3_18",
    d: "M618.602 263.586C618.602 265.288 617.046 266.715 615.064 266.715C613.083 266.715 611.526 265.288 611.526 263.586C611.526 261.884 613.083 260.457 615.064 260.457C617.046 260.457 618.602 261.884 618.602 263.586Z",
    stroke: "black",
    strokeWidth: 0.5
  }))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Line 21",
    d: "M618.22 263.586H633.371",
    stroke: "black",
    strokeWidth: 3
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 37",
    d: "M637.791 217.402H639.685L641.579 215.431V213.46V211.488L639.685 209.517H637.791",
    stroke: "black",
    strokeWidth: 0.25
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 38",
    d: "M637.791 267.529H639.685L641.579 265.557V263.586V261.615L639.685 259.644H637.791",
    stroke: "black",
    strokeWidth: 0.25
  }))), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "LB2TRACKSIDE_DG_UP_WIRE",
    d: "M838.545 224.161V213.46H641.578",
    stroke: "black",
    strokeWidth: 2
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "LB2TRACKSIDE_DG_DN_WIRE",
    d: "M838.545 251.195V263.586H641.578",
    stroke: "black",
    strokeWidth: 2
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 33",
    d: "M677.563 209.644L679.457 211.897L681.351 209.644",
    stroke: "black",
    strokeWidth: 2
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 34",
    d: "M708.497 260.207L710.391 262.46L712.285 260.207",
    stroke: "black",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "DPR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan65 || (_tspan65 = /*#__PURE__*/React.createElement("tspan", {
    x: 678.194,
    y: 208.415
  }, "DPR"))), /*#__PURE__*/React.createElement("text", {
    id: "DPR_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan66 || (_tspan66 = /*#__PURE__*/React.createElement("tspan", {
    x: 679.457,
    y: 259.105
  }, "DPR"))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group 7"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2_19",
    cx: 722.387,
    cy: 213.46,
    rx: 2.52522,
    ry: 2.25287,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3_19",
    d: "M725.174 213.46C725.174 214.67 724.036 215.839 722.386 215.839C720.736 215.839 719.599 214.67 719.599 213.46C719.599 212.25 720.736 211.081 722.386 211.081C724.036 211.081 725.174 212.25 725.174 213.46Z",
    stroke: "black",
    strokeWidth: 2
  }))), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 40",
    cx: 709.76,
    cy: 214.023,
    rx: 2.52522,
    ry: 2.25287,
    fill: "black"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 41",
    d: "M673.407 213.46C673.407 214.67 672.269 215.839 670.619 215.839C668.969 215.839 667.831 214.67 667.831 213.46C667.831 212.25 668.969 211.081 670.619 211.081C672.269 211.081 673.407 212.25 673.407 213.46Z",
    stroke: "black",
    strokeWidth: 2
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 42",
    cx: 684.508,
    cy: 264.149,
    rx: 2.52522,
    ry: 2.25287,
    transform: "rotate(-180 684.508 264.149)",
    fill: "black"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 94",
    cx: 130.434,
    cy: 215.023,
    r: 4,
    fill: "black"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 95",
    cx: 150.635,
    cy: 215.023,
    r: 4,
    fill: "black"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 27",
    d: "M277.946 208.954L281.103 213.46L285.522 208.954",
    stroke: "black",
    strokeWidth: 2
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 62",
    d: "M175.675 208.954L178.831 213.46L183.25 208.954",
    stroke: "black",
    strokeWidth: 2
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 32",
    d: "M296.886 246.126L300.042 250.632L304.461 246.126",
    stroke: "black",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "R1_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan67 || (_tspan67 = /*#__PURE__*/React.createElement("tspan", {
    x: 358.753,
    y: 248.967
  }, "R1"))), /*#__PURE__*/React.createElement("text", {
    id: "C1",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan68 || (_tspan68 = /*#__PURE__*/React.createElement("tspan", {
    x: 174.412,
    y: 225.311
  }, "C1"))), /*#__PURE__*/React.createElement("text", {
    id: "C2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan69 || (_tspan69 = /*#__PURE__*/React.createElement("tspan", {
    x: 197.139,
    y: 225.311
  }, "C2"))), /*#__PURE__*/React.createElement("text", {
    id: "A1",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan70 || (_tspan70 = /*#__PURE__*/React.createElement("tspan", {
    x: 277.946,
    y: 225.311
  }, "A1"))), /*#__PURE__*/React.createElement("text", {
    id: "A2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan71 || (_tspan71 = /*#__PURE__*/React.createElement("tspan", {
    x: 276.684,
    y: 263.61
  }, "A2"))), /*#__PURE__*/React.createElement("text", {
    id: "A1_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan72 || (_tspan72 = /*#__PURE__*/React.createElement("tspan", {
    x: 293.098,
    y: 263.61
  }, "A1"))), /*#__PURE__*/React.createElement("text", {
    id: "A2_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan73 || (_tspan73 = /*#__PURE__*/React.createElement("tspan", {
    x: 296.886,
    y: 225.311
  }, "A2"))), /*#__PURE__*/React.createElement("text", {
    id: "HR_5",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan74 || (_tspan74 = /*#__PURE__*/React.createElement("tspan", {
    x: 209.766,
    y: 208.415
  }, "HR"))), /*#__PURE__*/React.createElement("text", {
    id: "DR1_5",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan75 || (_tspan75 = /*#__PURE__*/React.createElement("tspan", {
    x: 290.573,
    y: 244.461
  }, "DR1"))), /*#__PURE__*/React.createElement("text", {
    id: "DECR_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan76 || (_tspan76 = /*#__PURE__*/React.createElement("tspan", {
    x: 334.764,
    y: 262.484
  }, "DECR"))), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 28",
    cx: 282.997,
    cy: 250.632,
    rx: 3.78783,
    ry: 3.37931,
    fill: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "0.6A_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan77 || (_tspan77 = /*#__PURE__*/React.createElement("tspan", {
    x: 131.484,
    y: 206.162
  }, "0.6A"))), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "RR_UP_WIRE_DG",
    d: "M442.086 213.46L127.696 215.116",
    stroke: "black",
    strokeWidth: 2
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "RR_DN_WIRE_DG",
    d: "M442.39 251L128 252.696",
    stroke: "black",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "B18 SPD"
  }, /*#__PURE__*/React.createElement("text", {
    id: "6_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan78 || (_tspan78 = /*#__PURE__*/React.createElement("tspan", {
    x: 439.56,
    y: 224.185
  }, "6"))), /*#__PURE__*/React.createElement("text", {
    id: "5_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan79 || (_tspan79 = /*#__PURE__*/React.createElement("tspan", {
    x: 462.287,
    y: 224.185
  }, "5"))), /*#__PURE__*/React.createElement("text", {
    id: "1_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan80 || (_tspan80 = /*#__PURE__*/React.createElement("tspan", {
    x: 462.287,
    y: 261.357
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    id: "2_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan81 || (_tspan81 = /*#__PURE__*/React.createElement("tspan", {
    x: 440.822,
    y: 261.357
  }, "2"))), /*#__PURE__*/React.createElement("text", {
    id: "4_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan82 || (_tspan82 = /*#__PURE__*/React.createElement("tspan", {
    x: 440.822,
    y: 277.127
  }, "4"))), /*#__PURE__*/React.createElement("text", {
    id: "3_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan83 || (_tspan83 = /*#__PURE__*/React.createElement("tspan", {
    x: 462.287,
    y: 277.127
  }, "3"))), /*#__PURE__*/React.createElement("text", {
    id: "SPD_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan84 || (_tspan84 = /*#__PURE__*/React.createElement("tspan", {
    x: 440.822,
    y: 201.656
  }, "SPD"))), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 22",
    cx: 443.347,
    cy: 213.46,
    rx: 3.78783,
    ry: 3.37931,
    fill: "black"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 33",
    d: "M467.6 213.46C467.6 214.67 466.462 215.839 464.812 215.839C463.162 215.839 462.024 214.67 462.024 213.46C462.024 212.25 463.162 211.08 464.812 211.08C466.462 211.08 467.6 212.25 467.6 213.46Z",
    stroke: "black",
    strokeWidth: 2
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 34",
    cx: 443.347,
    cy: 250.632,
    rx: 3.78783,
    ry: 3.37931,
    fill: "black"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 35",
    d: "M467.6 250.632C467.6 251.842 466.462 253.011 464.812 253.011C463.162 253.011 462.024 251.842 462.024 250.632C462.024 249.422 463.162 248.253 464.812 248.253C466.462 248.253 467.6 249.422 467.6 250.632Z",
    stroke: "black",
    strokeWidth: 2
  })), _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 36",
    cx: 443.347,
    cy: 266.402,
    rx: 3.78783,
    ry: 3.37931,
    fill: "black"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 37",
    d: "M467.6 266.402C467.6 267.612 466.462 268.782 464.812 268.782C463.162 268.782 462.024 267.612 462.024 266.402C462.024 265.192 463.162 264.023 464.812 264.023C466.462 264.023 467.6 265.192 467.6 266.402Z",
    stroke: "black",
    strokeWidth: 2
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Line 18",
    d: "M445.873 213.46H461.656",
    stroke: "black",
    strokeWidth: 2
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Line 19",
    d: "M445.873 250.632H461.656",
    stroke: "black",
    strokeWidth: 2
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Line 20",
    d: "M445.873 266.402H461.656",
    stroke: "black",
    strokeWidth: 2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 7",
    x: 432,
    y: 205,
    width: 44,
    height: 74,
    stroke: "black",
    strokeWidth: 2
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Line 24",
    d: "M454.711 282.172V266.935",
    stroke: "black",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line 25",
    x1: 448.398,
    y1: 281.735,
    x2: 461.025,
    y2: 281.735,
    stroke: "black",
    strokeWidth: 2
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Line 26",
    d: "M449.661 283.158H460.155",
    stroke: "black",
    strokeWidth: 2
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Line 27",
    d: "M450.924 283.637H458.499",
    stroke: "black",
    strokeWidth: 2
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Line 28",
    d: "M452.187 284.144H457.237",
    stroke: "black",
    strokeWidth: 2
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Line 29",
    d: "M453.449 284.763H455.974",
    stroke: "black",
    strokeWidth: 2
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Line 32",
    d: "M452.187 284.144H457.237",
    stroke: "black",
    strokeWidth: 2
  }))), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "SPD2CTR_DG_DN_WIRE",
    d: "M488.803 263.586H611.276",
    stroke: "black",
    strokeWidth: 2
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "SPD2CTR_DG_DN_WIRE_2",
    d: "M468.602 250.632H488.803V264.149",
    stroke: "black",
    strokeWidth: 2
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "SPD2CTR_DG_UP_WIRE",
    d: "M467.97 213.46H612.055",
    stroke: "black",
    strokeWidth: 2
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "4ASP_LED Signal DG"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1_3",
    d: "M852.697 238.241C852.697 245.361 846.189 251.322 837.914 251.322C829.64 251.322 823.132 245.361 823.132 238.241C823.132 231.122 829.64 225.161 837.914 225.161C846.189 225.161 852.697 231.122 852.697 238.241Z",
    stroke: "black",
    strokeWidth: 2
  }))), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3",
    x: 813.031,
    y: 204.885,
    width: 48.5044,
    height: 66.7126,
    stroke: "black",
    strokeWidth: 2
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "Line 151",
    d: "M130 214.871C139.13 191.625 140 236.633 150 214.871",
    stroke: "black"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 22",
    d: "M318.351 251.195V266.966H361.279V251.195",
    stroke: "black",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "BX110_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan85 || (_tspan85 = /*#__PURE__*/React.createElement("tspan", {
    x: 89.3027,
    y: 218.817
  }, "BX110"))), /*#__PURE__*/React.createElement("text", {
    id: "NX110_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan86 || (_tspan86 = /*#__PURE__*/React.createElement("tspan", {
    x: 89.3027,
    y: 257.495
  }, "NX110"))), /*#__PURE__*/React.createElement("text", {
    id: "DG",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 6,
    letterSpacing: "0em"
  }, _tspan87 || (_tspan87 = /*#__PURE__*/React.createElement("tspan", {
    x: 865.061,
    y: 244.486
  }, "DG"))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Group 10"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2_20",
    cx: 722.386,
    cy: 263.586,
    rx: 2.52522,
    ry: 2.25287,
    transform: "rotate(-180 722.386 263.586)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3_20",
    d: "M719.598 263.586C719.598 262.376 720.736 261.207 722.386 261.207C724.036 261.207 725.174 262.376 725.174 263.586C725.174 264.796 724.036 265.966 722.386 265.966C720.736 265.966 719.598 264.796 719.598 263.586Z",
    stroke: "black",
    strokeWidth: 2
  }))), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 43",
    d: "M667.832 263.586C667.832 262.376 668.969 261.207 670.619 261.207C672.269 261.207 673.407 262.376 673.407 263.586C673.407 264.796 672.269 265.966 670.619 265.966C668.969 265.966 667.832 264.796 667.832 263.586Z",
    stroke: "black",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "D1",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan88 || (_tspan88 = /*#__PURE__*/React.createElement("tspan", {
    x: 198.401,
    y: 263.61
  }, "D1"))), /*#__PURE__*/React.createElement("text", {
    id: "D2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan89 || (_tspan89 = /*#__PURE__*/React.createElement("tspan", {
    x: 173.149,
    y: 262.484
  }, "D2"))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "S1DPR"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 38",
    cx: 670.619,
    cy: 213.46,
    rx: 2.52522,
    ry: 2.25287,
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 39",
    cx: 670.619,
    cy: 263.586,
    rx: 2.52522,
    ry: 2.25287,
    fill: "black"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "R2_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan90 || (_tspan90 = /*#__PURE__*/React.createElement("tspan", {
    x: 313.3,
    y: 248.967
  }, "R2"))), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 63",
    d: "M199.664 246.126L202.821 250.632L207.24 246.126",
    stroke: "black",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "DR_5",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan91 || (_tspan91 = /*#__PURE__*/React.createElement("tspan", {
    x: 306.986,
    y: 207.288
  }, "DR"))), /*#__PURE__*/React.createElement("text", {
    id: "HR_6",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan92 || (_tspan92 = /*#__PURE__*/React.createElement("tspan", {
    x: 183.251,
    y: 244.461
  }, "HR"))), _ellipse35 || (_ellipse35 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 23",
    cx: 300.674,
    cy: 214.586,
    rx: 3.78783,
    ry: 3.37931,
    fill: "black"
  })), _ellipse36 || (_ellipse36 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 24",
    cx: 203.452,
    cy: 214.586,
    rx: 3.78783,
    ry: 3.37931,
    fill: "black"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 29",
    cx: 176.649,
    cy: 251.753,
    r: 3.5,
    fill: "black"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 96",
    cx: 128.67,
    cy: 253.006,
    r: 3.5,
    fill: "black"
  }))), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "Line 152",
    d: "M131 359.871C140.13 336.625 141 381.633 151 359.871",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 162"
  }, _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 189",
    x: 921,
    y: -2,
    width: 420,
    height: 576,
    fill: "black"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 158",
    d: "M1147 394.138C1147 402.316 1140.49 408.914 1132.5 408.914C1124.51 408.914 1118 402.316 1118 394.138C1118 385.961 1124.51 379.362 1132.5 379.362C1140.49 379.362 1147 385.961 1147 394.138Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 2
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 157",
    d: "M1147 338.158C1147 346.335 1140.49 352.934 1132.5 352.934C1124.51 352.934 1118 346.335 1118 338.158C1118 329.98 1124.51 323.381 1132.5 323.381C1140.49 323.381 1147 329.98 1147 338.158Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 2
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 156",
    d: "M1147 287.267C1147 295.444 1140.49 302.043 1132.5 302.043C1124.51 302.043 1118 295.444 1118 287.267C1118 279.089 1124.51 272.49 1132.5 272.49C1140.49 272.49 1147 279.089 1147 287.267Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 2
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 172",
    d: "M1100.5 232.225C1100.5 214.828 1114.6 200.725 1132 200.725C1149.4 200.725 1163.5 214.828 1163.5 232.225V422.664H1100.5V232.225Z",
    stroke: "white",
    strokeWidth: 3
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 184",
    d: "M1111.5 456.842C1111.5 445.244 1120.9 435.842 1132.5 435.842C1144.1 435.842 1153.5 445.244 1153.5 456.842V483.734H1111.5V456.842Z",
    stroke: "white",
    strokeWidth: 3
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 155",
    d: "M1146 234.34C1146 242.517 1139.49 249.116 1131.5 249.116C1123.51 249.116 1117 242.517 1117 234.34C1117 226.162 1123.51 219.563 1131.5 219.563C1139.49 219.563 1146 226.162 1146 234.34Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 2
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "HHG_Aspect",
    d: "M1143 234.34C1143 240.831 1137.83 246.062 1131.5 246.062C1125.17 246.062 1120 240.831 1120 234.34C1120 227.848 1125.17 222.617 1131.5 222.617C1137.83 222.617 1143 227.848 1143 234.34Z",
    fill: "#979393",
    stroke: "white",
    strokeWidth: 2
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "DG_Aspect",
    d: "M1144 287.267C1144 293.758 1138.83 298.989 1132.5 298.989C1126.17 298.989 1121 293.758 1121 287.267C1121 280.775 1126.17 275.544 1132.5 275.544C1138.83 275.544 1144 280.775 1144 287.267Z",
    fill: "#979393",
    stroke: "white",
    strokeWidth: 2
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "HG_Aspect",
    d: "M1144 338.158C1144 344.649 1138.83 349.881 1132.5 349.881C1126.17 349.881 1121 344.649 1121 338.158C1121 331.667 1126.17 326.435 1132.5 326.435C1138.83 326.435 1144 331.667 1144 338.158Z",
    fill: "#979393",
    stroke: "white",
    strokeWidth: 2
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: "RG_Aspect",
    d: "M1144 394.138C1144 400.629 1138.83 405.861 1132.5 405.861C1126.17 405.861 1121 400.629 1121 394.138C1121 387.647 1126.17 382.415 1132.5 382.415C1138.83 382.415 1144 387.647 1144 394.138Z",
    fill: "#979393",
    stroke: "white",
    strokeWidth: 2
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 160",
    d: "M1147 463.35C1147 471.528 1140.49 478.127 1132.5 478.127C1124.51 478.127 1118 471.528 1118 463.35C1118 455.173 1124.51 448.574 1132.5 448.574C1140.49 448.574 1147 455.173 1147 463.35Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 2
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    id: "Calling_HG",
    d: "M1144 463.35C1144 469.841 1138.83 475.073 1132.5 475.073C1126.17 475.073 1121 469.841 1121 463.35C1121 456.859 1126.17 451.627 1132.5 451.627C1138.83 451.627 1144 456.859 1144 463.35Z",
    fill: "#979393",
    stroke: "white",
    strokeWidth: 2
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 159",
    d: "M1151.94 176.066C1151.8 188.161 1142.3 197.775 1130.81 197.631C1119.32 197.488 1110.05 187.64 1110.19 175.545C1110.33 163.451 1119.82 153.837 1131.31 153.98C1142.8 154.123 1152.07 163.972 1151.94 176.066Z",
    stroke: "white",
    strokeWidth: 2
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    id: "BCDEUG",
    d: "M1141.5 176.164C1141.43 182.085 1136.78 186.791 1131.16 186.721C1125.53 186.651 1120.99 181.83 1121.06 175.909C1121.13 169.988 1125.78 165.282 1131.4 165.352C1137.02 165.422 1141.56 170.243 1141.5 176.164Z",
    fill: "white",
    stroke: "white"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Route_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 185",
    d: "M1032.08 176.427C1033.34 179.763 1031.72 183.467 1028.51 184.715C1025.3 185.962 1021.67 184.296 1020.42 180.959C1019.16 177.623 1020.78 173.919 1023.99 172.672C1027.2 171.424 1030.83 173.09 1032.08 176.427Z",
    fill: "black",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 184",
    d: "M1055.16 180.598C1056.41 183.934 1054.8 187.638 1051.58 188.885C1048.37 190.133 1044.74 188.467 1043.49 185.13C1042.24 181.793 1043.85 178.09 1047.07 176.842C1050.28 175.595 1053.91 177.261 1055.16 180.598Z",
    fill: "black",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 183",
    d: "M1078.39 184.434C1079.64 187.771 1078.02 191.475 1074.81 192.722C1071.6 193.969 1067.97 192.303 1066.72 188.967C1065.47 185.63 1067.08 181.926 1070.29 180.679C1073.5 179.432 1077.13 181.098 1078.39 184.434Z",
    fill: "black",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 182",
    d: "M1101.54 188.694C1102.79 192.031 1101.17 195.735 1097.96 196.982C1094.75 198.229 1091.12 196.563 1089.87 193.227C1088.61 189.89 1090.23 186.186 1093.44 184.939C1096.65 183.692 1100.28 185.358 1101.54 188.694Z",
    fill: "black",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 174",
    x: 1.14267,
    y: -0.813094,
    width: 17.7483,
    height: 105.092,
    rx: 8.87413,
    transform: "matrix(0.164311 -0.991785 0.978361 0.178691 1009.16 185.45)",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "BUG2",
    d: "M1077.9 184.634C1079.05 187.7 1077.57 191.102 1074.62 192.247C1071.67 193.393 1068.34 191.863 1067.19 188.797C1066.04 185.731 1067.52 182.329 1070.47 181.184C1073.42 180.039 1076.75 181.568 1077.9 184.634Z",
    fill: "#D9D9D9",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BUG3",
    d: "M1054.68 180.797C1055.83 183.863 1054.34 187.265 1051.39 188.41C1048.45 189.556 1045.11 188.026 1043.96 184.96C1042.81 181.894 1044.29 178.492 1047.24 177.347C1050.19 176.202 1053.53 177.731 1054.68 180.797Z",
    fill: "#D9D9D9",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BUG4",
    d: "M1031.6 176.627C1032.75 179.693 1031.27 183.095 1028.32 184.24C1025.37 185.385 1022.04 183.856 1020.88 180.79C1019.73 177.724 1021.22 174.322 1024.17 173.177C1027.12 172.031 1030.45 173.561 1031.6 176.627Z",
    fill: "#D9D9D9",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BUG1",
    d: "M1101.05 188.894C1102.2 191.96 1100.72 195.362 1097.77 196.507C1094.82 197.653 1091.49 196.123 1090.33 193.057C1089.18 189.991 1090.67 186.589 1093.62 185.444C1096.57 184.299 1099.9 185.828 1101.05 188.894Z",
    fill: "#D9D9D9",
    stroke: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Route_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 185_2",
    d: "M1032.01 143.763C1032.66 147.275 1030.42 150.626 1027.04 151.271C1023.67 151.916 1020.39 149.62 1019.74 146.108C1019.09 142.596 1021.33 139.245 1024.7 138.6C1028.08 137.955 1031.36 140.251 1032.01 143.763Z",
    fill: "black",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 184_2",
    d: "M1053.99 152.049C1054.63 155.561 1052.4 158.912 1049.02 159.557C1045.64 160.202 1042.36 157.906 1041.71 154.394C1041.06 150.881 1043.3 147.531 1046.68 146.886C1050.05 146.24 1053.34 148.536 1053.99 152.049Z",
    fill: "black",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 183_2",
    d: "M1076.17 160.033C1076.82 163.545 1074.58 166.896 1071.2 167.541C1067.83 168.186 1064.55 165.89 1063.9 162.378C1063.25 158.866 1065.49 155.515 1068.86 154.87C1072.24 154.225 1075.52 156.521 1076.17 160.033Z",
    fill: "black",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 182_2",
    d: "M1098.2 168.42C1098.85 171.932 1096.61 175.283 1093.24 175.928C1089.86 176.573 1086.58 174.277 1085.93 170.765C1085.28 167.253 1087.52 163.902 1090.9 163.257C1094.27 162.612 1097.56 164.908 1098.2 168.42Z",
    fill: "black",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 174_2",
    x: 1.2671,
    y: -0.592013,
    width: 17.7638,
    height: 105.009,
    rx: 8.88192,
    transform: "matrix(0.334911 -0.945417 0.932187 0.353404 1007.63 148.527)",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "BUG2_2",
    d: "M1075.66 160.143C1076.26 163.37 1074.2 166.448 1071.1 167.04C1068 167.632 1064.98 165.524 1064.39 162.297C1063.79 159.069 1065.85 155.992 1068.95 155.399C1072.05 154.807 1075.07 156.915 1075.66 160.143Z",
    fill: "#D9D9D9",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BUG3_2",
    d: "M1053.48 152.158C1054.07 155.385 1052.02 158.463 1048.92 159.055C1045.82 159.647 1042.8 157.539 1042.2 154.312C1041.61 151.084 1043.67 148.007 1046.77 147.414C1049.87 146.822 1052.88 148.93 1053.48 152.158Z",
    fill: "#D9D9D9",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BUG4_2",
    d: "M1031.5 143.872C1032.1 147.1 1030.04 150.177 1026.94 150.77C1023.84 151.362 1020.82 149.254 1020.23 146.026C1019.63 142.798 1021.69 139.721 1024.79 139.129C1027.89 138.537 1030.9 140.645 1031.5 143.872Z",
    fill: "#D9D9D9",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BUG1_2",
    d: "M1097.69 168.529C1098.29 171.757 1096.23 174.834 1093.13 175.427C1090.03 176.019 1087.02 173.911 1086.42 170.683C1085.83 167.456 1087.88 164.378 1090.98 163.786C1094.08 163.194 1097.1 165.302 1097.69 168.529Z",
    fill: "#D9D9D9",
    stroke: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Route_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 185_3",
    d: "M1048.08 109.884C1047.87 113.452 1044.89 116.145 1041.46 115.932C1038.03 115.719 1035.4 112.678 1035.61 109.11C1035.83 105.542 1038.8 102.849 1042.23 103.062C1045.66 103.275 1048.29 106.316 1048.08 109.884Z",
    fill: "black",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 184_3",
    d: "M1067.4 123.377C1067.19 126.945 1064.22 129.638 1060.79 129.425C1057.36 129.212 1054.73 126.171 1054.94 122.603C1055.15 119.035 1058.13 116.342 1061.55 116.555C1064.98 116.767 1067.62 119.809 1067.4 123.377Z",
    fill: "black",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 183_3",
    d: "M1087 136.63C1086.79 140.198 1083.82 142.89 1080.39 142.678C1076.96 142.465 1074.33 139.424 1074.54 135.856C1074.75 132.288 1077.73 129.595 1081.16 129.808C1084.58 130.02 1087.22 133.062 1087 136.63Z",
    fill: "black",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 182_3",
    d: "M1106.36 150.235C1106.15 153.803 1103.17 156.496 1099.75 156.283C1096.32 156.07 1093.68 153.029 1093.9 149.461C1094.11 145.893 1097.08 143.2 1100.51 143.413C1103.94 143.626 1106.57 146.667 1106.36 150.235Z",
    fill: "black",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 174_3",
    x: 1.37079,
    y: -0.259034,
    width: 17.7697,
    height: 104.979,
    rx: 8.88483,
    transform: "matrix(0.551263 -0.833425 0.81953 0.57439 1022.96 108.344)",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "BUG2_3",
    d: "M1086.48 136.609C1086.29 139.888 1083.55 142.361 1080.41 142.165C1077.26 141.97 1074.84 139.177 1075.04 135.898C1075.23 132.619 1077.96 130.146 1081.11 130.342C1084.26 130.537 1086.68 133.33 1086.48 136.609Z",
    fill: "#D9D9D9",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BUG3_3",
    d: "M1066.88 123.356C1066.69 126.635 1063.95 129.108 1060.81 128.912C1057.66 128.717 1055.24 125.924 1055.44 122.645C1055.63 119.366 1058.36 116.893 1061.51 117.089C1064.66 117.284 1067.08 120.077 1066.88 123.356Z",
    fill: "#D9D9D9",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BUG4_3",
    d: "M1047.56 109.863C1047.36 113.142 1044.63 115.615 1041.48 115.42C1038.33 115.224 1035.91 112.432 1036.11 109.153C1036.3 105.874 1039.04 103.401 1042.19 103.596C1045.33 103.792 1047.75 106.584 1047.56 109.863Z",
    fill: "#D9D9D9",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BUG1_3",
    d: "M1105.84 150.214C1105.64 153.493 1102.91 155.966 1099.76 155.771C1096.62 155.575 1094.2 152.783 1094.39 149.504C1094.59 146.225 1097.32 143.752 1100.47 143.947C1103.62 144.143 1106.04 146.935 1105.84 150.214Z",
    fill: "#D9D9D9",
    stroke: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Route_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 185_4",
    d: "M1095.66 76.0088C1093.66 78.9383 1089.74 79.6695 1086.92 77.6694C1084.09 75.6694 1083.4 71.6772 1085.4 68.7476C1087.4 65.8181 1091.32 65.0869 1094.14 67.087C1096.97 69.0871 1097.66 73.0793 1095.66 76.0088Z",
    fill: "black",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 184_4",
    d: "M1105.27 97.7619C1103.27 100.691 1099.36 101.423 1096.53 99.4226C1093.71 97.4225 1093.02 93.4303 1095.02 90.5008C1097.02 87.5713 1100.93 86.8401 1103.76 88.8402C1106.58 90.8402 1107.27 94.8324 1105.27 97.7619Z",
    fill: "black",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 183_4",
    d: "M1115.24 119.456C1113.24 122.386 1109.33 123.117 1106.5 121.117C1103.68 119.117 1102.99 115.124 1104.99 112.195C1106.99 109.265 1110.9 108.534 1113.73 110.534C1116.55 112.534 1117.24 116.527 1115.24 119.456Z",
    fill: "black",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 182_4",
    d: "M1124.83 141.322C1122.83 144.252 1118.91 144.983 1116.08 142.983C1113.26 140.983 1112.57 136.991 1114.57 134.061C1116.57 131.132 1120.49 130.401 1123.31 132.401C1126.14 134.401 1126.83 138.393 1124.83 141.322Z",
    fill: "black",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 174_4",
    x: 1.30451,
    y: 0.500892,
    width: 17.7193,
    height: 105.244,
    rx: 8.85965,
    transform: "matrix(0.898948 -0.421197 0.405564 0.922089 1074.74 60.6662)",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "BUG2_4",
    d: "M1114.81 119.163C1112.97 121.855 1109.37 122.526 1106.78 120.689C1104.19 118.852 1103.55 115.185 1105.39 112.494C1107.23 109.802 1110.83 109.131 1113.42 110.968C1116.01 112.804 1116.65 116.471 1114.81 119.163Z",
    fill: "#D9D9D9",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BUG3_4",
    d: "M1104.84 97.4695C1103 100.161 1099.4 100.832 1096.81 98.9955C1094.21 97.1588 1093.58 93.4918 1095.42 90.8C1097.26 88.1082 1100.85 87.4373 1103.45 89.274C1106.04 91.1107 1106.68 94.7777 1104.84 97.4695Z",
    fill: "#D9D9D9",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BUG4_4",
    d: "M1095.22 75.7157C1093.39 78.4075 1089.79 79.0784 1087.19 77.2417C1084.6 75.405 1083.96 71.738 1085.8 69.0462C1087.64 66.3545 1091.24 65.6835 1093.83 67.5202C1096.43 69.3569 1097.06 73.024 1095.22 75.7157Z",
    fill: "#D9D9D9",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BUG1_4",
    d: "M1124.39 141.029C1122.55 143.721 1118.96 144.392 1116.36 142.555C1113.77 140.719 1113.13 137.052 1114.97 134.36C1116.81 131.668 1120.41 130.997 1123 132.834C1125.6 134.671 1126.23 138.338 1124.39 141.029Z",
    fill: "#D9D9D9",
    stroke: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Route_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 185_5",
    d: "M1163.23 73.3429C1159.87 74.3056 1156.38 72.3453 1155.45 68.9608C1154.51 65.5762 1156.48 62.0538 1159.84 61.0911C1163.21 60.1284 1166.69 62.0887 1167.63 65.4733C1168.56 68.8578 1166.59 72.3803 1163.23 73.3429Z",
    fill: "black",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 184_5",
    d: "M1157.06 96.3545C1153.7 97.3171 1150.21 95.3568 1149.28 91.9723C1148.34 88.5878 1150.31 85.0653 1153.68 84.1026C1157.04 83.14 1160.52 85.1003 1161.46 88.4848C1162.39 91.8694 1160.42 95.3918 1157.06 96.3545Z",
    fill: "black",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 183_5",
    d: "M1151.2 119.552C1147.84 120.515 1144.36 118.554 1143.42 115.17C1142.49 111.785 1144.46 108.263 1147.82 107.3C1151.18 106.337 1154.67 108.298 1155.6 111.682C1156.54 115.067 1154.56 118.589 1151.2 119.552Z",
    fill: "black",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 182_5",
    d: "M1144.94 142.631C1141.58 143.594 1138.09 141.633 1137.16 138.249C1136.22 134.864 1138.2 131.342 1141.56 130.379C1144.92 129.417 1148.4 131.377 1149.34 134.761C1150.27 138.146 1148.3 141.668 1144.94 142.631Z",
    fill: "black",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 174_5",
    x: 0.700001,
    y: 1.22748,
    width: 17.6213,
    height: 105.756,
    rx: 8.81065,
    transform: "matrix(0.961736 0.257944 -0.261735 0.969535 1157.43 47.4051)",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "BUG2_5",
    d: "M1151.05 119.045C1147.96 119.929 1144.76 118.129 1143.9 115.019C1143.05 111.91 1144.86 108.675 1147.94 107.79C1151.03 106.906 1154.23 108.707 1155.09 111.816C1155.95 114.925 1154.14 118.161 1151.05 119.045Z",
    fill: "#D9D9D9",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BUG3_5",
    d: "M1156.91 95.8483C1153.82 96.7325 1150.62 94.9319 1149.76 91.8228C1148.9 88.7137 1150.71 85.4781 1153.8 84.5939C1156.89 83.7096 1160.09 85.5102 1160.95 88.6193C1161.8 91.7284 1159.99 94.964 1156.91 95.8483Z",
    fill: "#D9D9D9",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BUG4_5",
    d: "M1163.08 72.8358C1159.99 73.72 1156.79 71.9194 1155.93 68.8103C1155.07 65.7012 1156.88 62.4656 1159.97 61.5814C1163.06 60.6971 1166.26 62.4977 1167.12 65.6068C1167.97 68.7159 1166.16 71.9515 1163.08 72.8358Z",
    fill: "#D9D9D9",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BUG1_5",
    d: "M1144.79 142.124C1141.7 143.008 1138.5 141.208 1137.64 138.099C1136.78 134.99 1138.59 131.754 1141.68 130.87C1144.77 129.985 1147.97 131.786 1148.83 134.895C1149.69 138.004 1147.88 141.24 1144.79 142.124Z",
    fill: "#D9D9D9",
    stroke: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Route_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 185_6",
    d: "M1206.09 101.985C1202.67 101.269 1200.46 97.8999 1201.15 94.4556C1201.85 91.0112 1205.19 88.8036 1208.61 89.5193C1212.03 90.235 1214.24 93.6044 1213.55 97.0487C1212.85 100.493 1209.51 102.701 1206.09 101.985Z",
    fill: "black",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 184_6",
    d: "M1190.23 119.545C1186.81 118.829 1184.6 115.46 1185.29 112.016C1185.99 108.571 1189.33 106.364 1192.75 107.079C1196.17 107.795 1198.38 111.165 1197.69 114.609C1196.99 118.053 1193.65 120.261 1190.23 119.545Z",
    fill: "black",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 183_6",
    d: "M1174.56 137.417C1171.14 136.701 1168.93 133.332 1169.63 129.887C1170.32 126.443 1173.66 124.235 1177.08 124.951C1180.5 125.667 1182.72 129.036 1182.02 132.48C1181.32 135.925 1177.98 138.132 1174.56 137.417Z",
    fill: "black",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 182_6",
    d: "M1158.59 154.993C1155.17 154.277 1152.96 150.908 1153.65 147.464C1154.35 144.019 1157.69 141.812 1161.11 142.527C1164.53 143.243 1166.74 146.612 1166.05 150.057C1165.35 153.501 1162.01 155.709 1158.59 154.993Z",
    fill: "black",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 174_6",
    x: 0.0686474,
    y: 1.41757,
    width: 17.6142,
    height: 105.793,
    rx: 8.80712,
    transform: "matrix(0.738285 0.67883 -0.669638 0.738739 1213.23 76.523)",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "BUG2_6",
    d: "M1174.66 136.895C1171.52 136.238 1169.48 133.143 1170.12 129.979C1170.76 126.815 1173.83 124.787 1176.97 125.444C1180.11 126.102 1182.15 129.197 1181.51 132.361C1180.87 135.525 1177.8 137.553 1174.66 136.895Z",
    fill: "#D9D9D9",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BUG3_6",
    d: "M1190.32 119.025C1187.18 118.367 1185.15 115.272 1185.79 112.108C1186.43 108.944 1189.5 106.916 1192.64 107.574C1195.78 108.231 1197.81 111.326 1197.17 114.49C1196.53 117.654 1193.46 119.682 1190.32 119.025Z",
    fill: "#D9D9D9",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BUG4_6",
    d: "M1206.18 101.464C1203.04 100.806 1201.01 97.7113 1201.65 94.5472C1202.29 91.3831 1205.36 89.3554 1208.5 90.0127C1211.64 90.6701 1213.67 93.7651 1213.03 96.9292C1212.39 100.093 1209.32 102.121 1206.18 101.464Z",
    fill: "#D9D9D9",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BUG1_6",
    d: "M1158.68 154.471C1155.54 153.814 1153.51 150.719 1154.15 147.555C1154.79 144.391 1157.86 142.363 1161 143.02C1164.14 143.678 1166.17 146.773 1165.53 149.937C1164.89 153.101 1161.82 155.129 1158.68 154.471Z",
    fill: "#D9D9D9",
    stroke: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Route_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 185_7",
    d: "M1231.97 188.289C1229.93 185.393 1230.55 181.391 1233.35 179.346C1236.14 177.302 1240.07 177.971 1242.12 180.867C1244.16 183.762 1243.54 187.764 1240.74 189.809C1237.95 191.854 1234.02 191.185 1231.97 188.289Z",
    fill: "black",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 184_7",
    d: "M1208.62 190.265C1206.57 187.369 1207.2 183.367 1209.99 181.322C1212.79 179.277 1216.72 179.947 1218.76 182.842C1220.81 185.738 1220.18 189.74 1217.39 191.785C1214.59 193.83 1210.66 193.16 1208.62 190.265Z",
    fill: "black",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 183_7",
    d: "M1185.2 192.603C1183.15 189.708 1183.78 185.706 1186.57 183.661C1189.37 181.616 1193.3 182.285 1195.34 185.181C1197.39 188.077 1196.76 192.079 1193.97 194.124C1191.17 196.168 1187.24 195.499 1185.2 192.603Z",
    fill: "black",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 182_7",
    d: "M1161.75 194.513C1159.7 191.617 1160.33 187.615 1163.12 185.57C1165.92 183.525 1169.85 184.195 1171.89 187.09C1173.94 189.986 1173.31 193.988 1170.52 196.033C1167.72 198.077 1163.8 197.408 1161.75 194.513Z",
    fill: "black",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 174_7",
    x: -0.898434,
    y: 1.0852,
    width: 17.7133,
    height: 105.275,
    rx: 8.85663,
    transform: "matrix(0.0905854 1.00335 -0.98902 0.0818536 1253.93 175.488)",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "BUG2_7",
    d: "M1185.61 192.285C1183.73 189.624 1184.31 185.948 1186.88 184.07C1189.44 182.192 1193.05 182.806 1194.93 185.467C1196.81 188.128 1196.24 191.804 1193.67 193.681C1191.1 195.559 1187.49 194.945 1185.61 192.285Z",
    fill: "#D9D9D9",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BUG3_7",
    d: "M1209.03 189.946C1207.15 187.286 1207.73 183.61 1210.3 181.732C1212.86 179.854 1216.47 180.468 1218.35 183.129C1220.23 185.79 1219.65 189.465 1217.09 191.343C1214.52 193.221 1210.91 192.607 1209.03 189.946Z",
    fill: "#D9D9D9",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BUG4_7",
    d: "M1232.39 187.97C1230.51 185.309 1231.08 181.633 1233.65 179.756C1236.22 177.878 1239.83 178.492 1241.71 181.152C1243.59 183.813 1243.01 187.489 1240.44 189.367C1237.88 191.245 1234.27 190.631 1232.39 187.97Z",
    fill: "#D9D9D9",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BUG1_7",
    d: "M1162.17 194.194C1160.28 191.533 1160.86 187.857 1163.43 185.979C1165.99 184.101 1169.6 184.715 1171.48 187.376C1173.36 190.037 1172.79 193.713 1170.22 195.59C1167.65 197.468 1164.05 196.854 1162.17 194.194Z",
    fill: "#D9D9D9",
    stroke: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Route_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 185_8",
    d: "M1231.54 144.908C1228.71 142.821 1228.06 138.823 1230.08 135.98C1232.11 133.137 1236.04 132.517 1238.88 134.604C1241.71 136.691 1242.36 140.689 1240.34 143.532C1238.31 146.376 1234.38 146.996 1231.54 144.908Z",
    fill: "black",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 184_8",
    d: "M1209.99 154.279C1207.16 152.192 1206.51 148.194 1208.53 145.351C1210.56 142.508 1214.49 141.888 1217.32 143.975C1220.16 146.063 1220.81 150.06 1218.79 152.904C1216.76 155.747 1212.83 156.367 1209.99 154.279Z",
    fill: "black",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 183_8",
    d: "M1188.49 164.015C1185.66 161.928 1185.01 157.93 1187.03 155.087C1189.06 152.244 1192.99 151.624 1195.83 153.711C1198.66 155.799 1199.31 159.796 1197.29 162.64C1195.26 165.483 1191.33 166.103 1188.49 164.015Z",
    fill: "black",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 182_8",
    d: "M1166.83 173.353C1164 171.266 1163.35 167.268 1165.37 164.425C1167.4 161.582 1171.33 160.962 1174.16 163.049C1177 165.137 1177.65 169.134 1175.63 171.978C1173.6 174.821 1169.67 175.441 1166.83 173.353Z",
    fill: "black",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 174_8",
    x: -0.513085,
    y: 1.31961,
    width: 17.6623,
    height: 105.542,
    rx: 8.83115,
    transform: "matrix(0.397848 0.925471 -0.910933 0.394136 1248.48 125.265)",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "BUG2_8",
    d: "M1188.79 163.579C1186.19 161.662 1185.59 157.989 1187.45 155.378C1189.31 152.767 1192.92 152.197 1195.52 154.114C1198.13 156.032 1198.72 159.704 1196.87 162.316C1195.01 164.927 1191.39 165.497 1188.79 163.579Z",
    fill: "#D9D9D9",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BUG3_8",
    d: "M1210.29 153.844C1207.69 151.927 1207.09 148.254 1208.95 145.643C1210.8 143.031 1214.42 142.462 1217.02 144.379C1219.63 146.296 1220.22 149.969 1218.37 152.58C1216.51 155.192 1212.89 155.761 1210.29 153.844Z",
    fill: "#D9D9D9",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BUG4_8",
    d: "M1231.84 144.472C1229.24 142.555 1228.64 138.882 1230.5 136.271C1232.36 133.66 1235.97 133.09 1238.57 135.007C1241.18 136.925 1241.78 140.597 1239.92 143.209C1238.06 145.82 1234.44 146.39 1231.84 144.472Z",
    fill: "#D9D9D9",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BUG1_8",
    d: "M1167.13 172.917C1164.53 171 1163.93 167.327 1165.79 164.716C1167.64 162.105 1171.26 161.535 1173.86 163.452C1176.47 165.37 1177.06 169.042 1175.21 171.654C1173.35 174.265 1169.73 174.835 1167.13 172.917Z",
    fill: "#D9D9D9",
    stroke: "white"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "VRG",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan93 || (_tspan93 = /*#__PURE__*/React.createElement("tspan", {
    x: 1196,
    y: 259.944
  }))), /*#__PURE__*/React.createElement("text", {
    id: "VHHG",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan94 || (_tspan94 = /*#__PURE__*/React.createElement("tspan", {
    x: 1198,
    y: 493.864
  }))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 177",
    x: 1189.5,
    y: 220.5,
    width: 137,
    height: 333,
    rx: 4.5,
    stroke: "white"
  })), /*#__PURE__*/React.createElement("text", {
    id: "HPR_3",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan95 || (_tspan95 = /*#__PURE__*/React.createElement("tspan", {
    x: 946,
    y: 494.152
  }))), /*#__PURE__*/React.createElement("text", {
    id: "BUG_V",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan96 || (_tspan96 = /*#__PURE__*/React.createElement("tspan", {
    x: 946,
    y: 252.997
  }))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 178",
    x: 939.5,
    y: 218.5,
    width: 137,
    height: 335,
    rx: 4.5,
    stroke: "white"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SG_NAME",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    letterSpacing: "0em"
  }, _tspan97 || (_tspan97 = /*#__PURE__*/React.createElement("tspan", {
    x: 1237,
    y: 59.4082
  }))), /*#__PURE__*/React.createElement("text", {
    id: "LOC_NAME",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    letterSpacing: "0em"
  }, _tspan98 || (_tspan98 = /*#__PURE__*/React.createElement("tspan", {
    x: 938,
    y: 59.4082
  }))), /*#__PURE__*/React.createElement("text", {
    id: "ROOT_TIME",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan99 || (_tspan99 = /*#__PURE__*/React.createElement("tspan", {
    x: 948,
    y: 233.597
  }))), /*#__PURE__*/React.createElement("text", {
    id: "ASPECT_TIME",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan100 || (_tspan100 = /*#__PURE__*/React.createElement("tspan", {
    x: 1197,
    y: 233.597
  }))), /*#__PURE__*/React.createElement("text", {
    id: "ASPECT_TIME_2",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan101 || (_tspan101 = /*#__PURE__*/React.createElement("tspan", {
    x: 1198,
    y: 471.909
  }))), /*#__PURE__*/React.createElement("text", {
    id: "PROVING_RELAY_TIME",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan102 || (_tspan102 = /*#__PURE__*/React.createElement("tspan", {
    x: 948,
    y: 471.877
  }))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 183",
    x: 1127,
    y: 424.164,
    width: 12,
    height: 11.1961,
    fill: "#D9D9D9"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 185",
    x: 1028,
    y: 224.67,
    width: 43,
    height: 11.1961,
    rx: 5,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("text", {
    id: "ROUTE",
    transform: "translate(1035 224.67)",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan103 || (_tspan103 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.90909
  }, "ROUTE"))), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 187",
    x: 1028,
    y: 463.968,
    width: 43,
    height: 11.1961,
    rx: 5,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("text", {
    id: "RELAYS",
    transform: "translate(1035 463.968)",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan104 || (_tspan104 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.90909
  }, "RELAYS"))), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 188",
    x: 1274,
    y: 463,
    width: 43,
    height: 11.1961,
    rx: 5,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("text", {
    id: "CALLING",
    transform: "translate(1278 464)",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan105 || (_tspan105 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.90909
  }, "CALLING"))), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 186",
    x: 1277,
    y: 224.67,
    width: 43,
    height: 11.1961,
    rx: 5,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("text", {
    id: "MAIN",
    transform: "translate(1289 224.67)",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan106 || (_tspan106 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.90909
  }, "MAIN")))), /*#__PURE__*/React.createElement("g", {
    id: "RG_Wiring"
  }, /*#__PURE__*/React.createElement("text", {
    id: "RGNX",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan107 || (_tspan107 = /*#__PURE__*/React.createElement("tspan", {
    x: 375.168,
    y: 536.208
  }, "RGNX"))), /*#__PURE__*/React.createElement("text", {
    id: "RGBX",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan108 || (_tspan108 = /*#__PURE__*/React.createElement("tspan", {
    x: 375.168,
    y: 500.162
  }, "RGBX"))), /*#__PURE__*/React.createElement("g", {
    id: "CTR A5/7"
  }, /*#__PURE__*/React.createElement("text", {
    id: "CTR_7",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan109 || (_tspan109 = /*#__PURE__*/React.createElement("tspan", {
    x: 616.326,
    y: 495.656
  }, "CTR"))), /*#__PURE__*/React.createElement("text", {
    id: "CTR_8",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan110 || (_tspan110 = /*#__PURE__*/React.createElement("tspan", {
    x: 616.326,
    y: 546.346
  }, "CTR"))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Group 20"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2_21",
    cx: 636.527,
    cy: 500.701,
    rx: 2.52522,
    ry: 2.25287,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3_21",
    d: "M640.065 500.701C640.065 502.403 638.509 503.83 636.527 503.83C634.546 503.83 632.989 502.403 632.989 500.701C632.989 498.999 634.546 497.572 636.527 497.572C638.509 497.572 640.065 498.999 640.065 500.701Z",
    stroke: "black",
    strokeWidth: 0.5
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "Group 21"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2_22",
    cx: 615.064,
    cy: 500.701,
    rx: 2.52522,
    ry: 2.25287,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3_22",
    d: "M618.602 500.701C618.602 502.403 617.046 503.83 615.064 503.83C613.083 503.83 611.526 502.403 611.526 500.701C611.526 498.999 613.083 497.572 615.064 497.572C617.046 497.572 618.602 498.999 618.602 500.701Z",
    stroke: "black",
    strokeWidth: 0.5
  }))), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    id: "Line 49",
    d: "M618.22 500.701H633.371",
    stroke: "black",
    strokeWidth: 3
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "Group 23"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2_23",
    cx: 636.527,
    cy: 550.828,
    rx: 2.52522,
    ry: 2.25287,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3_23",
    d: "M640.065 550.828C640.065 552.53 638.509 553.957 636.527 553.957C634.546 553.957 632.989 552.53 632.989 550.828C632.989 549.125 634.546 547.698 636.527 547.698C638.509 547.698 640.065 549.125 640.065 550.828Z",
    stroke: "black",
    strokeWidth: 0.5
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "Group 24"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2_24",
    cx: 615.064,
    cy: 550.828,
    rx: 2.52522,
    ry: 2.25287,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3_24",
    d: "M618.602 550.828C618.602 552.53 617.046 553.957 615.064 553.957C613.083 553.957 611.526 552.53 611.526 550.828C611.526 549.125 613.083 547.698 615.064 547.698C617.046 547.698 618.602 549.125 618.602 550.828Z",
    stroke: "black",
    strokeWidth: 0.5
  }))), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    id: "Line 53",
    d: "M618.22 550.828H633.371",
    stroke: "black",
    strokeWidth: 3
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 77",
    d: "M637.791 504.644H639.685L641.579 502.672V500.701V498.73L639.685 496.759H637.791",
    stroke: "black",
    strokeWidth: 0.25
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 78",
    d: "M637.791 554.77H639.685L641.579 552.799V550.828V548.856L639.685 546.885H637.791",
    stroke: "black",
    strokeWidth: 0.25
  }))), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    id: "LB2TRACKSIDE_RG_UP_WIRE",
    d: "M838.545 511.402V500.701H641.578",
    stroke: "black",
    strokeWidth: 2
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    id: "LB2TRACKSIDE_RG_DN_WIRE",
    d: "M838.545 538.437V550.828H641.578",
    stroke: "black",
    strokeWidth: 2
  })), _ellipse37 || (_ellipse37 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 80",
    cx: 670.618,
    cy: 500.701,
    rx: 2.52522,
    ry: 2.25287,
    fill: "black"
  })), _ellipse38 || (_ellipse38 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 81",
    cx: 670.618,
    cy: 550.828,
    rx: 2.52522,
    ry: 2.25287,
    fill: "black"
  })), _ellipse39 || (_ellipse39 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2_25",
    cx: 722.386,
    cy: 500.701,
    rx: 2.52522,
    ry: 2.25287,
    fill: "black"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3_25",
    d: "M725.173 500.701C725.173 501.911 724.036 503.08 722.385 503.08C720.735 503.08 719.598 501.911 719.598 500.701C719.598 499.491 720.735 498.322 722.385 498.322C724.036 498.322 725.173 499.491 725.173 500.701Z",
    stroke: "black",
    strokeWidth: 2
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 83",
    d: "M673.406 500.701C673.406 501.911 672.268 503.08 670.618 503.08C668.968 503.08 667.83 501.911 667.83 500.701C667.83 499.491 668.968 498.322 670.618 498.322C672.268 498.322 673.406 499.491 673.406 500.701Z",
    stroke: "black",
    strokeWidth: 2
  })), _ellipse40 || (_ellipse40 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2_26",
    cx: 722.385,
    cy: 550.828,
    rx: 2.52522,
    ry: 2.25287,
    transform: "rotate(-180 722.385 550.828)",
    fill: "black"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3_26",
    d: "M719.597 550.827C719.597 549.618 720.735 548.448 722.385 548.448C724.035 548.448 725.173 549.618 725.173 550.827C725.173 552.037 724.035 553.207 722.385 553.207C720.735 553.207 719.597 552.037 719.597 550.827Z",
    stroke: "black",
    strokeWidth: 2
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 85",
    d: "M667.831 550.827C667.831 549.618 668.968 548.448 670.618 548.448C672.268 548.448 673.406 549.618 673.406 550.827C673.406 552.037 672.268 553.207 670.618 553.207C668.968 553.207 667.831 552.037 667.831 550.827Z",
    stroke: "black",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "R2_4",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan111 || (_tspan111 = /*#__PURE__*/React.createElement("tspan", {
    x: 314.562,
    y: 534.208
  }, "R2"))), /*#__PURE__*/React.createElement("text", {
    id: "R1_4",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan112 || (_tspan112 = /*#__PURE__*/React.createElement("tspan", {
    x: 360.016,
    y: 534.208
  }, "R1"))), /*#__PURE__*/React.createElement("text", {
    id: "RECR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan113 || (_tspan113 = /*#__PURE__*/React.createElement("tspan", {
    x: 326.501,
    y: 548.725
  }, "RECR"))), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 90",
    cx: 129.17,
    cy: 539.747,
    r: 4,
    fill: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "BX110_4",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan114 || (_tspan114 = /*#__PURE__*/React.createElement("tspan", {
    x: 89,
    y: 503.909
  }, "BX110"))), /*#__PURE__*/React.createElement("text", {
    id: "NX110_4",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan115 || (_tspan115 = /*#__PURE__*/React.createElement("tspan", {
    x: 89,
    y: 545.587
  }, "NX110"))), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 88",
    cx: 130.434,
    cy: 502.138,
    r: 4,
    fill: "black"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 89",
    cx: 150.635,
    cy: 502.138,
    r: 4,
    fill: "black"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 64",
    d: "M318.351 538.437V554.207H360.017V538.437",
    stroke: "black",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "4Asp_UP_RECR"
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 65",
    d: "M221.129 473.103L217.341 468.598L213.553 473.103",
    stroke: "black",
    strokeWidth: 2
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 66",
    d: "M179.463 506.896L175.675 502.391L171.887 506.896",
    stroke: "black",
    strokeWidth: 2
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 69",
    d: "M171.887 473.103L175.675 468.598L179.462 473.103",
    stroke: "black",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "DECR_4",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan116 || (_tspan116 = /*#__PURE__*/React.createElement("tspan", {
    x: 198.401,
    y: 461.863
  }, "DECR"))), /*#__PURE__*/React.createElement("text", {
    id: "HHECR_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan117 || (_tspan117 = /*#__PURE__*/React.createElement("tspan", {
    x: 251.432,
    y: 461.863
  }, "HHECR"))), /*#__PURE__*/React.createElement("text", {
    id: "HECR_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan118 || (_tspan118 = /*#__PURE__*/React.createElement("tspan", {
    x: 308.249,
    y: 461.863
  }, "HECR"))), /*#__PURE__*/React.createElement("text", {
    id: "HR_7",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan119 || (_tspan119 = /*#__PURE__*/React.createElement("tspan", {
    x: 193.24,
    y: 491.53
  }, "HR"))), _ellipse41 || (_ellipse41 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 67",
    cx: 200.926,
    cy: 500.701,
    rx: 3.78783,
    ry: 3.37931,
    fill: "black"
  })), _ellipse42 || (_ellipse42 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 70",
    cx: 192.089,
    cy: 468.034,
    rx: 3.78783,
    ry: 3.37931,
    fill: "black"
  })), _ellipse43 || (_ellipse43 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 97_2",
    cx: 245.119,
    cy: 468.034,
    rx: 3.78783,
    ry: 3.37931,
    fill: "black"
  })), _ellipse44 || (_ellipse44 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 98_2",
    cx: 301.936,
    cy: 468.034,
    rx: 3.78783,
    ry: 3.37931,
    fill: "black"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 82",
    d: "M277.946 473.667L274.158 468.598L270.371 473.667",
    stroke: "black",
    strokeWidth: 2
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 80",
    d: "M175.675 502.391L164.312 495.857V468.26H318.981V495.857H216.71L204.715 500.926",
    stroke: "black",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "4Asp_DN_RECR"
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 83",
    d: "M194.614 575.609L190.826 571.103L187.039 575.609",
    stroke: "black",
    strokeWidth: 2
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 84",
    d: "M245.118 575.609L241.33 571.103L237.543 575.609",
    stroke: "black",
    strokeWidth: 2
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 85",
    d: "M299.411 574.483L295.623 569.977L291.835 574.483",
    stroke: "black",
    strokeWidth: 2
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 67",
    d: "M200.927 544.632L196.508 540.126L193.351 544.632",
    stroke: "black",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "DECPR_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan120 || (_tspan120 = /*#__PURE__*/React.createElement("tspan", {
    x: 178.199,
    y: 563.242
  }, "DECPR"))), /*#__PURE__*/React.createElement("text", {
    id: "HHECR_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan121 || (_tspan121 = /*#__PURE__*/React.createElement("tspan", {
    x: 228.704,
    y: 563.242
  }, "HHECR"))), /*#__PURE__*/React.createElement("text", {
    id: "HECR_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan122 || (_tspan122 = /*#__PURE__*/React.createElement("tspan", {
    x: 281.733,
    y: 563.242
  }, "HECR"))), _ellipse45 || (_ellipse45 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 71",
    cx: 171.887,
    cy: 539,
    rx: 3.78783,
    ry: 3.37931,
    fill: "black"
  })), _ellipse46 || (_ellipse46 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 72",
    cx: 171.887,
    cy: 570.54,
    rx: 3.78783,
    ry: 3.37931,
    fill: "black"
  })), _ellipse47 || (_ellipse47 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 73",
    cx: 222.391,
    cy: 570.202,
    rx: 3.78783,
    ry: 3.37931,
    fill: "black"
  })), _ellipse48 || (_ellipse48 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 87",
    cx: 275.422,
    cy: 569.977,
    rx: 3.78783,
    ry: 3.37931,
    fill: "black"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 81",
    d: "M196.508 539L209.766 544.069L313.3 543.168V568.851L161.787 570.766V543.168L171.256 538.099",
    stroke: "black",
    strokeWidth: 2
  }))), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    id: "RR_UP_WIRE_RG",
    d: "M442.086 500.701L127.696 502.357",
    stroke: "black",
    strokeWidth: 2
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    id: "RR_DN_WIRE_RG",
    d: "M442.086 537.873L127.696 539.57",
    stroke: "black",
    strokeWidth: 2
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    id: "SPD2CTR_RG_DN_WIRE",
    d: "M488.803 550.828H611.276",
    stroke: "black",
    strokeWidth: 2
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    id: "SPD2CTR_RG_DN_WIRE_2",
    d: "M468.602 537.874H488.803V551.391",
    stroke: "black",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "B20SPD"
  }, /*#__PURE__*/React.createElement("text", {
    id: "6_4",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan123 || (_tspan123 = /*#__PURE__*/React.createElement("tspan", {
    x: 439.56,
    y: 511.426
  }, "6"))), /*#__PURE__*/React.createElement("text", {
    id: "5_4",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan124 || (_tspan124 = /*#__PURE__*/React.createElement("tspan", {
    x: 462.287,
    y: 511.426
  }, "5"))), /*#__PURE__*/React.createElement("text", {
    id: "1_4",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan125 || (_tspan125 = /*#__PURE__*/React.createElement("tspan", {
    x: 462.287,
    y: 548.599
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    id: "2_4",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan126 || (_tspan126 = /*#__PURE__*/React.createElement("tspan", {
    x: 440.822,
    y: 548.599
  }, "2"))), /*#__PURE__*/React.createElement("text", {
    id: "4_4",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan127 || (_tspan127 = /*#__PURE__*/React.createElement("tspan", {
    x: 440.822,
    y: 564.369
  }, "4"))), /*#__PURE__*/React.createElement("text", {
    id: "3_4",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan128 || (_tspan128 = /*#__PURE__*/React.createElement("tspan", {
    x: 462.287,
    y: 564.369
  }, "3"))), /*#__PURE__*/React.createElement("text", {
    id: "SPD_4",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan129 || (_tspan129 = /*#__PURE__*/React.createElement("tspan", {
    x: 440.822,
    y: 488.898
  }, "SPD"))), _ellipse49 || (_ellipse49 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 66",
    cx: 443.347,
    cy: 500.701,
    rx: 3.78783,
    ry: 3.37931,
    fill: "black"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 75",
    d: "M467.6 500.701C467.6 501.911 466.462 503.08 464.812 503.08C463.162 503.08 462.024 501.911 462.024 500.701C462.024 499.491 463.162 498.322 464.812 498.322C466.462 498.322 467.6 499.491 467.6 500.701Z",
    stroke: "black",
    strokeWidth: 2
  })), _ellipse50 || (_ellipse50 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 76",
    cx: 443.347,
    cy: 537.873,
    rx: 3.78783,
    ry: 3.37931,
    fill: "black"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 77",
    d: "M467.6 537.873C467.6 539.083 466.462 540.253 464.812 540.253C463.162 540.253 462.024 539.083 462.024 537.873C462.024 536.664 463.162 535.494 464.812 535.494C466.462 535.494 467.6 536.664 467.6 537.873Z",
    stroke: "black",
    strokeWidth: 2
  })), _ellipse51 || (_ellipse51 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 78",
    cx: 443.347,
    cy: 553.644,
    rx: 3.78783,
    ry: 3.37931,
    fill: "black"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 79",
    d: "M467.6 553.644C467.6 554.853 466.462 556.023 464.812 556.023C463.162 556.023 462.024 554.853 462.024 553.644C462.024 552.434 463.162 551.264 464.812 551.264C466.462 551.264 467.6 552.434 467.6 553.644Z",
    stroke: "black",
    strokeWidth: 2
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    id: "Line 50",
    d: "M445.873 500.701H461.656",
    stroke: "black",
    strokeWidth: 2
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    id: "Line 51",
    d: "M445.873 537.874H461.656",
    stroke: "black",
    strokeWidth: 2
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    id: "Line 52",
    d: "M445.873 553.644H461.656",
    stroke: "black",
    strokeWidth: 2
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 9",
    x: 432,
    y: 492,
    width: 44,
    height: 74,
    stroke: "black",
    strokeWidth: 2
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    id: "Line 56",
    d: "M454.711 569.414V554.176",
    stroke: "black",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "Line 57",
    x1: 448.398,
    y1: 568.977,
    x2: 461.025,
    y2: 568.977,
    stroke: "black",
    strokeWidth: 2
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    id: "Line 58",
    d: "M449.661 570.399H460.155",
    stroke: "black",
    strokeWidth: 2
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    id: "Line 59",
    d: "M450.924 570.878H458.499",
    stroke: "black",
    strokeWidth: 2
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    id: "Line 60",
    d: "M452.187 571.385H457.237",
    stroke: "black",
    strokeWidth: 2
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    id: "Line 61",
    d: "M453.449 572.005H455.974",
    stroke: "black",
    strokeWidth: 2
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    id: "Line 64",
    d: "M452.187 571.385H457.237",
    stroke: "black",
    strokeWidth: 2
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "4ASP_LED Signal HG"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1_4",
    d: "M852.697 525.483C852.697 532.603 846.189 538.563 837.914 538.563C829.64 538.563 823.132 532.603 823.132 525.483C823.132 518.363 829.64 512.402 837.914 512.402C846.189 512.402 852.697 518.363 852.697 525.483Z",
    stroke: "black",
    strokeWidth: 2
  }))), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4",
    x: 813.031,
    y: 493.253,
    width: 48.5044,
    height: 66.7126,
    stroke: "black",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "RG",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 6,
    letterSpacing: "0em"
  }, _tspan130 || (_tspan130 = /*#__PURE__*/React.createElement("tspan", {
    x: 863.798,
    y: 529.475
  }, "RG"))), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    id: "Line 153",
    d: "M130 501.871C139.13 478.625 140 523.633 150 501.871",
    stroke: "black"
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "SPD2CTR_MONITOR_RG"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SPD2CTR_UP_RG_WIRE",
    d: "M468.601 500.701H611.055",
    stroke: "black",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 164"
  }, /*#__PURE__*/React.createElement("text", {
    id: "0.6A_4",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan131 || (_tspan131 = /*#__PURE__*/React.createElement("tspan", {
    x: 131.484,
    y: 493.403
  }, "0.6A"))), /*#__PURE__*/React.createElement("text", {
    id: "HR1",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan132 || (_tspan132 = /*#__PURE__*/React.createElement("tspan", {
    x: 178.199,
    y: 532.829
  }, "HR1")))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_384_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1408,
    height: 633,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignal4Asp);
export default __webpack_public_path__ + "static/media/signal_4asp.e282c085437317ffc6e957ed1203db65.svg";
export { ForwardRef as ReactComponent };